import { S as SDL_REDESIGN_HEADER_SELECTOR, e as SDL_HEADER_SELECTOR_APC, f as SDL_HEADER_SELECTOR, g as SLASH, h as Protocol, O as ONLINE_CTA_TYPES, i as scrollBehavior, T as TAB_BAR_HEIGHT, j as EEvent, k as ClientApps, l as CartVersion, n as BAZAAR_VOICE_URL, o as breadcrumbsLevels, M as MAX_BREADCRUMBS_RECORDS_COUNT, A as ALLPRODUCTS, q as BreadcrumbTypes, r as BUSINESS, t as CircularProductTypes, u as STATUS_TYPES, v as REQUEST_ERRORS, w as REQUEST_ERROR_TYPES, D as DEFAULT_CONFIGURATIONS, x as DEFAULT_API_VERSION_FORMAT, y as RESPONSE_TYPES, F as FeatureStatus, z as PES_FLAGS } from './currency-7be6806c.js';
import { g as global, p as process_1, B as Buffer, l as lodash } from './lodash-bd96d09c.js';
import { p as pageLoadDataParams } from './analytics-205f1857.js';
import { c as createCommonjsModule, a as commonjsGlobal } from './_commonjsHelpers-11ca3be1.js';
import './_nodeUtil-f95b2b52.js';
import { _ as _MapCache } from './_Stack-68736bd1.js';

// Commerce connector API is called in all our pes pages
const ATG_COMMERCE_CONNECTOR_PATH = '/product/pdp/commerce-connector';
// Product-software is called in PDP pages for software products
const ATG_PRODUCT_SOFTWARE_PATH = '/product/api/product-software';
// product card main and secondary API is used called in range ,category listing and comparision pages.
const ATG_PRODUCT_CARD_ADDITION_PATH = '/product/api/productCard/addition';
const ATG_PRODUCT_CARD_MAIN_PATH = '/product/api/productCard/main';
// My products is called in range and pdp and also in category and subcategory listing products
const ATG_MY_PRODUCTS_REST_URL = '/product/my-products';
const ATG_ANALYTICS_LOOKUPS = '/product/api/analytics/lookups';

// Commerce connector API is called in all our pes pages
const SPRYKER_COMMERCE_CONNECTOR_PATH = '/commerce-connector';
// product card main and secondary API is used called in range ,category listing and comparision pages.
const SPRYKER_PRODUCT_CARD_MAIN_PATH = '/products-card/main';
const SPRYKER_PRODUCT_CARD_SECONDARY_PATH = '/products-card/secondary';
const SPRYKER_PRODUCTS_ALL_PATH = '/products/#product_id#/all';
const SPRYKER_DDC_CONFIG_PATH = '/ddc-config';
// My products is called in range and pdp and also in category and subcategory listing products
const SPRYKER_MY_PRODUCTS_REST_URL = '/my-products';
const SPRYKER_ANALYTICS_LOOKUPS = '/analytics';
const SPRYKER_PRODUCTS_SUBSTITUTION = '/products-substitution';

const INDEXDB_CREATION_KEY = 'addedAt';

const list = [
    { country: 'WW', language: ['en'] },
    { country: 'AE', language: ['en'] },
    { country: 'AR', language: ['es'] },
    { country: 'AT', language: ['de'] },
    { country: 'AU', language: ['en'] },
    { country: 'BE', language: ['fr', 'nl'] },
    { country: 'BG', language: ['bg'] },
    { country: 'BR', language: ['pt'] },
    { country: 'CA', language: ['en', 'fr'] },
    { country: 'CH', language: ['fr', 'de'] },
    { country: 'CL', language: ['es'] },
    { country: 'CN', language: ['zh'] },
    { country: 'CO', language: ['es'] },
    { country: 'CR', language: ['es'] },
    { country: 'CZ', language: ['cs'] },
    { country: 'DE', language: ['de'] },
    { country: 'DK', language: ['da'] },
    { country: 'DZ', language: ['fr'] },
    { country: 'EE', language: ['et'] },
    { country: 'EG', language: ['en', 'ar'] },
    { country: 'ES', language: ['es'] },
    { country: 'FI', language: ['fi'] },
    { country: 'FR', language: ['fr'] },
    { country: 'GR', language: ['el'] },
    { country: 'HK', language: ['en'] },
    { country: 'HR', language: ['hr'] },
    { country: 'HU', language: ['hu'] },
    { country: 'ID', language: ['en', 'id'] },
    { country: 'IE', language: ['en'] },
    { country: 'IL', language: ['en'] },
    { country: 'IN', language: ['en'] },
    { country: 'IT', language: ['it'] },
    { country: 'JP', language: ['ja'] },
    { country: 'KR', language: ['ko'] },
    { country: 'KZ', language: ['ru'] },
    { country: 'LT', language: ['lt'] },
    { country: 'LV', language: ['lv'] },
    { country: 'MA', language: ['fr'] },
    { country: 'MY', language: ['en'] },
    { country: 'NG', language: ['en'] },
    { country: 'NL', language: ['nl'] },
    { country: 'NO', language: ['no'] },
    { country: 'NZ', language: ['en'] },
    { country: 'PE', language: ['es'] },
    { country: 'PH', language: ['en'] },
    { country: 'PL', language: ['pl'] },
    { country: 'PT', language: ['pt'] },
    { country: 'RO', language: ['ro'] },
    { country: 'RS', language: ['sr'] },
    { country: 'RU', language: ['ru'] },
    { country: 'SA', language: ['en'] },
    { country: 'SE', language: ['sv'] },
    { country: 'SG', language: ['en'] },
    { country: 'SI', language: ['sl'] },
    { country: 'SK', language: ['sk'] },
    { country: 'TH', language: ['th', 'en'] },
    { country: 'TR', language: ['tr'] },
    { country: 'TW', language: ['zh'] },
    { country: 'UA', language: ['uk', 'ru'] },
    { country: 'UK', language: ['en'] },
    { country: 'US', language: ['en'] },
    { country: 'VN', language: ['vi', 'en'] },
    { country: 'ZA', language: ['en'] },
    { country: 'MX', language: ['es'] },
];

function isNullOrUndefined(value) {
    return typeof value === 'undefined' || value === null;
}
function getDefaultCountry(isUpperCase) {
    const defaultCountry = list[0].country;
    return isUpperCase ? defaultCountry.toUpperCase() : defaultCountry.toLowerCase();
}
function getExistOrDefaultLanguage(language) {
    const languages = list[0].language;
    return languages.includes(language) ? language : languages[0];
}
/**
 * Return validated and corrected (if need) country and language codes.
 * @param country country code.
 * @param language language code.
 */
const validate = (country, language) => {
    const result = { country, language };
    const COUNTRY = isNullOrUndefined(country) ? 'NO COUNTRY' : country.toUpperCase();
    const countryLanguages = list.find((countryLanguage) => countryLanguage.country === COUNTRY);
    if (countryLanguages) {
        if (!countryLanguages.language.includes(language)) {
            // eslint-disable-next-line prefer-destructuring
            result.language = countryLanguages.language[0];
        }
    }
    else {
        result.country = getDefaultCountry(country === COUNTRY);
        result.language = getExistOrDefaultLanguage(language);
    }
    return result;
};

function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

// utils is a library of generic helper functions non-specific to axios

const {toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
};

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean$1 = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject$2 = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
};

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

const [isReadableStream, isRequest, isResponse, isHeaders] = ['ReadableStream', 'Request', 'Response', 'Headers'].map(kindOfTest);

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject$2(result[targetKey]) && isPlainObject$2(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject$2(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  };

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
};

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
};

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
};

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
};

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
};

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
};

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
};

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  };

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
};

const noop$1 = () => {};

const toFiniteNumber = (value, defaultValue) => {
  return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};

const ALPHA = 'abcdefghijklmnopqrstuvwxyz';

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0];
  }

  return str;
};

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  };

  return visit(obj, 0);
};

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34

const _setImmediate = ((setImmediateSupported, postMessageSupported) => {
  if (setImmediateSupported) {
    return setImmediate;
  }

  return postMessageSupported ? ((token, callbacks) => {
    _global.addEventListener("message", ({source, data}) => {
      if (source === _global && data === token) {
        callbacks.length && callbacks.shift()();
      }
    }, false);

    return (cb) => {
      callbacks.push(cb);
      _global.postMessage(token, "*");
    }
  })(`axios@${Math.random()}`, []) : (cb) => setTimeout(cb);
})(
  typeof setImmediate === 'function',
  isFunction(_global.postMessage)
);

const asap = typeof queueMicrotask !== 'undefined' ?
  queueMicrotask.bind(_global) : ( typeof process_1 !== 'undefined' && process_1.nextTick || _setImmediate);

// *********************

const utils$1 = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean: isBoolean$1,
  isObject,
  isPlainObject: isPlainObject$2,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop: noop$1,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap
};

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  if (response) {
    this.response = response;
    this.status = response.status ? response.status : null;
  }
}

utils$1.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});

const prototype$1 = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);

  utils$1.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

// eslint-disable-next-line strict
const httpAdapter = null;

/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils$1.isPlainObject(thing) || utils$1.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils$1.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils$1.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils$1.toFlatObject(utils$1, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils$1.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils$1.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils$1.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils$1.isSpecCompliantForm(formData);

  if (!utils$1.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils$1.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils$1.isBlob(value)) {
      throw new AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils$1.isArrayBuffer(value) || utils$1.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils$1.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils$1.isArray(value) && isFlatArray(value)) ||
        ((utils$1.isFileList(value) || utils$1.endsWith(key, '[]')) && (arr = utils$1.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils$1.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils$1.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils$1.forEach(value, function each(el, key) {
      const result = !(utils$1.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils$1.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils$1.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode$1(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && toFormData(params, this, options);
}

const prototype = AxiosURLSearchParams.prototype;

prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode$1);
  } : encode$1;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?(object|Function)} options
 *
 * @returns {string} The formatted url
 */
function buildURL$1(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || encode;

  if (utils$1.isFunction(options)) {
    options = {
      serialize: options
    };
  } 

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils$1.isURLSearchParams(params) ?
      params.toString() :
      new AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils$1.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

const transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

const URLSearchParams$1 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : AxiosURLSearchParams;

const FormData$1 = typeof FormData !== 'undefined' ? FormData : null;

const Blob$1 = typeof Blob !== 'undefined' ? Blob : null;

const platform$1 = {
  isBrowser: true,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
};

const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';

const _navigator = typeof navigator === 'object' && navigator || undefined;

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const hasStandardBrowserEnv = hasBrowserEnv &&
  (!_navigator || ['ReactNative', 'NativeScript', 'NS'].indexOf(_navigator.product) < 0);

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
const hasStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();

const origin = hasBrowserEnv && window.location.href || 'http://localhost';

const utils = /*#__PURE__*/Object.freeze({
    __proto__: null,
    hasBrowserEnv: hasBrowserEnv,
    hasStandardBrowserWebWorkerEnv: hasStandardBrowserWebWorkerEnv,
    hasStandardBrowserEnv: hasStandardBrowserEnv,
    navigator: _navigator,
    origin: origin
});

const platform = {
  ...utils,
  ...platform$1
};

function toURLEncodedForm(data, options) {
  return toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils$1.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils$1.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];

    if (name === '__proto__') return true;

    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils$1.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils$1.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils$1.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils$1.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils$1.isFormData(formData) && utils$1.isFunction(formData.entries)) {
    const obj = {};

    utils$1.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils$1.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$1.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: transitionalDefaults,

  adapter: ['xhr', 'http', 'fetch'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils$1.isObject(data);

    if (isObjectPayload && utils$1.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils$1.isFormData(data);

    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }

    if (utils$1.isArrayBuffer(data) ||
      utils$1.isBuffer(data) ||
      utils$1.isStream(data) ||
      utils$1.isFile(data) ||
      utils$1.isBlob(data) ||
      utils$1.isReadableStream(data)
    ) {
      return data;
    }
    if (utils$1.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$1.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils$1.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (utils$1.isResponse(data) || utils$1.isReadableStream(data)) {
      return data;
    }

    if (data && utils$1.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

utils$1.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults.headers[method] = {};
});

// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils$1.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
const parseHeaders = rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};

const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils$1.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils$1.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils$1.isString(value)) return;

  if (utils$1.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils$1.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils$1.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils$1.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils$1.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils$1.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if(utils$1.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else if (utils$1.isHeaders(header)) {
      for (const [key, value] of header.entries()) {
        setHeader(value, key, rewrite);
      }
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils$1.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils$1.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils$1.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils$1.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils$1.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils$1.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils$1.forEach(this, (value, header) => {
      const key = utils$1.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils$1.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils$1.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils$1.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
utils$1.reduceDescriptors(AxiosHeaders.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

utils$1.freezeMethods(AxiosHeaders);

/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || defaults;
  const context = response || config;
  const headers = AxiosHeaders.from(context.headers);
  let data = context.data;

  utils$1.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils$1.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */
function throttle(fn, freq) {
  let timestamp = 0;
  let threshold = 1000 / freq;
  let lastArgs;
  let timer;

  const invoke = (args, now = Date.now()) => {
    timestamp = now;
    lastArgs = null;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    fn.apply(null, args);
  };

  const throttled = (...args) => {
    const now = Date.now();
    const passed = now - timestamp;
    if ( passed >= threshold) {
      invoke(args, now);
    } else {
      lastArgs = args;
      if (!timer) {
        timer = setTimeout(() => {
          timer = null;
          invoke(lastArgs);
        }, threshold - passed);
      }
    }
  };

  const flush = () => lastArgs && invoke(lastArgs);

  return [throttled, flush];
}

const progressEventReducer = (listener, isDownloadStream, freq = 3) => {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);

  return throttle(e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e,
      lengthComputable: total != null,
      [isDownloadStream ? 'download' : 'upload']: true
    };

    listener(data);
  }, freq);
};

const progressEventDecorator = (total, throttled) => {
  const lengthComputable = total != null;

  return [(loaded) => throttled[0]({
    lengthComputable,
    total,
    loaded
  }), throttled[1]];
};

const asyncDecorator = (fn) => (...args) => utils$1.asap(() => fn(...args));

const isURLSameOrigin = platform.hasStandardBrowserEnv ? ((origin, isMSIE) => (url) => {
  url = new URL(url, platform.origin);

  return (
    origin.protocol === url.protocol &&
    origin.host === url.host &&
    (isMSIE || origin.port === url.port)
  );
})(
  new URL(platform.origin),
  platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent)
) : () => true;

const cookies = platform.hasStandardBrowserEnv ?

  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + '=' + encodeURIComponent(value)];

      utils$1.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());

      utils$1.isString(path) && cookie.push('path=' + path);

      utils$1.isString(domain) && cookie.push('domain=' + domain);

      secure === true && cookie.push('secure');

      document.cookie = cookie.join('; ');
    },

    read(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return (match ? decodeURIComponent(match[3]) : null);
    },

    remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  }

  :

  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {},
    read() {
      return null;
    },
    remove() {}
  };

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

const headersToObject = (thing) => thing instanceof AxiosHeaders ? { ...thing } : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, prop, caseless) {
    if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
      return utils$1.merge.call({caseless}, target, source);
    } else if (utils$1.isPlainObject(source)) {
      return utils$1.merge({}, source);
    } else if (utils$1.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, prop , caseless) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(a, b, prop , caseless);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(undefined, a, prop , caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b , prop) => mergeDeepProperties(headersToObject(a), headersToObject(b),prop, true)
  };

  utils$1.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils$1.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

const resolveConfig = (config) => {
  const newConfig = mergeConfig({}, config);

  let {data, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth} = newConfig;

  newConfig.headers = headers = AxiosHeaders.from(headers);

  newConfig.url = buildURL$1(buildFullPath(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);

  // HTTP basic authentication
  if (auth) {
    headers.set('Authorization', 'Basic ' +
      btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : ''))
    );
  }

  let contentType;

  if (utils$1.isFormData(data)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
      headers.setContentType(undefined); // Let the browser set it
    } else if ((contentType = headers.getContentType()) !== false) {
      // fix semicolon duplication issue for ReactNative FormData implementation
      const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
      headers.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
    }
  }

  // Add xsrf header
  // This is only done if running in a standard browser environment.
  // Specifically not if we're in a web worker, or react-native.

  if (platform.hasStandardBrowserEnv) {
    withXSRFToken && utils$1.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));

    if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(newConfig.url))) {
      // Add xsrf header
      const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);

      if (xsrfValue) {
        headers.set(xsrfHeaderName, xsrfValue);
      }
    }
  }

  return newConfig;
};

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

const xhrAdapter = isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    const _config = resolveConfig(config);
    let requestData = _config.data;
    const requestHeaders = AxiosHeaders.from(_config.headers).normalize();
    let {responseType, onUploadProgress, onDownloadProgress} = _config;
    let onCanceled;
    let uploadThrottled, downloadThrottled;
    let flushUpload, flushDownload;

    function done() {
      flushUpload && flushUpload(); // flush events
      flushDownload && flushDownload(); // flush events

      _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);

      _config.signal && _config.signal.removeEventListener('abort', onCanceled);
    }

    let request = new XMLHttpRequest();

    request.open(_config.method.toUpperCase(), _config.url, true);

    // Set the request timeout in MS
    request.timeout = _config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = AxiosHeaders.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = _config.transitional || transitionalDefaults;
      if (_config.timeoutErrorMessage) {
        timeoutErrorMessage = _config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils$1.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils$1.isUndefined(_config.withCredentials)) {
      request.withCredentials = !!_config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = _config.responseType;
    }

    // Handle progress if needed
    if (onDownloadProgress) {
      ([downloadThrottled, flushDownload] = progressEventReducer(onDownloadProgress, true));
      request.addEventListener('progress', downloadThrottled);
    }

    // Not all browsers support upload events
    if (onUploadProgress && request.upload) {
      ([uploadThrottled, flushUpload] = progressEventReducer(onUploadProgress));

      request.upload.addEventListener('progress', uploadThrottled);

      request.upload.addEventListener('loadend', flushUpload);
    }

    if (_config.cancelToken || _config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
      if (_config.signal) {
        _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(_config.url);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
};

const composeSignals = (signals, timeout) => {
  const {length} = (signals = signals ? signals.filter(Boolean) : []);

  if (timeout || length) {
    let controller = new AbortController();

    let aborted;

    const onabort = function (reason) {
      if (!aborted) {
        aborted = true;
        unsubscribe();
        const err = reason instanceof Error ? reason : this.reason;
        controller.abort(err instanceof AxiosError ? err : new CanceledError(err instanceof Error ? err.message : err));
      }
    };

    let timer = timeout && setTimeout(() => {
      timer = null;
      onabort(new AxiosError(`timeout ${timeout} of ms exceeded`, AxiosError.ETIMEDOUT));
    }, timeout);

    const unsubscribe = () => {
      if (signals) {
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach(signal => {
          signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
      }
    };

    signals.forEach((signal) => signal.addEventListener('abort', onabort));

    const {signal} = controller;

    signal.unsubscribe = () => utils$1.asap(unsubscribe);

    return signal;
  }
};

const streamChunk = function* (chunk, chunkSize) {
  let len = chunk.byteLength;

  if (!chunkSize || len < chunkSize) {
    yield chunk;
    return;
  }

  let pos = 0;
  let end;

  while (pos < len) {
    end = pos + chunkSize;
    yield chunk.slice(pos, end);
    pos = end;
  }
};

const readBytes = async function* (iterable, chunkSize) {
  for await (const chunk of readStream(iterable)) {
    yield* streamChunk(chunk, chunkSize);
  }
};

const readStream = async function* (stream) {
  if (stream[Symbol.asyncIterator]) {
    yield* stream;
    return;
  }

  const reader = stream.getReader();
  try {
    for (;;) {
      const {done, value} = await reader.read();
      if (done) {
        break;
      }
      yield value;
    }
  } finally {
    await reader.cancel();
  }
};

const trackStream = (stream, chunkSize, onProgress, onFinish) => {
  const iterator = readBytes(stream, chunkSize);

  let bytes = 0;
  let done;
  let _onFinish = (e) => {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  };

  return new ReadableStream({
    async pull(controller) {
      try {
        const {done, value} = await iterator.next();

        if (done) {
         _onFinish();
          controller.close();
          return;
        }

        let len = value.byteLength;
        if (onProgress) {
          let loadedBytes = bytes += len;
          onProgress(loadedBytes);
        }
        controller.enqueue(new Uint8Array(value));
      } catch (err) {
        _onFinish(err);
        throw err;
      }
    },
    cancel(reason) {
      _onFinish(reason);
      return iterator.return();
    }
  }, {
    highWaterMark: 2
  })
};

const isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const isReadableStreamSupported = isFetchSupported && typeof ReadableStream === 'function';

// used only inside the fetch adapter
const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ?
    ((encoder) => (str) => encoder.encode(str))(new TextEncoder()) :
    async (str) => new Uint8Array(await new Response(str).arrayBuffer())
);

const test = (fn, ...args) => {
  try {
    return !!fn(...args);
  } catch (e) {
    return false
  }
};

const supportsRequestStream = isReadableStreamSupported && test(() => {
  let duplexAccessed = false;

  const hasContentType = new Request(platform.origin, {
    body: new ReadableStream(),
    method: 'POST',
    get duplex() {
      duplexAccessed = true;
      return 'half';
    },
  }).headers.has('Content-Type');

  return duplexAccessed && !hasContentType;
});

const DEFAULT_CHUNK_SIZE = 64 * 1024;

const supportsResponseStream = isReadableStreamSupported &&
  test(() => utils$1.isReadableStream(new Response('').body));


const resolvers = {
  stream: supportsResponseStream && ((res) => res.body)
};

isFetchSupported && (((res) => {
  ['text', 'arrayBuffer', 'blob', 'formData', 'stream'].forEach(type => {
    !resolvers[type] && (resolvers[type] = utils$1.isFunction(res[type]) ? (res) => res[type]() :
      (_, config) => {
        throw new AxiosError(`Response type '${type}' is not supported`, AxiosError.ERR_NOT_SUPPORT, config);
      });
  });
})(new Response));

const getBodyLength = async (body) => {
  if (body == null) {
    return 0;
  }

  if(utils$1.isBlob(body)) {
    return body.size;
  }

  if(utils$1.isSpecCompliantForm(body)) {
    const _request = new Request(platform.origin, {
      method: 'POST',
      body,
    });
    return (await _request.arrayBuffer()).byteLength;
  }

  if(utils$1.isArrayBufferView(body) || utils$1.isArrayBuffer(body)) {
    return body.byteLength;
  }

  if(utils$1.isURLSearchParams(body)) {
    body = body + '';
  }

  if(utils$1.isString(body)) {
    return (await encodeText(body)).byteLength;
  }
};

const resolveBodyLength = async (headers, body) => {
  const length = utils$1.toFiniteNumber(headers.getContentLength());

  return length == null ? getBodyLength(body) : length;
};

const fetchAdapter = isFetchSupported && (async (config) => {
  let {
    url,
    method,
    data,
    signal,
    cancelToken,
    timeout,
    onDownloadProgress,
    onUploadProgress,
    responseType,
    headers,
    withCredentials = 'same-origin',
    fetchOptions
  } = resolveConfig(config);

  responseType = responseType ? (responseType + '').toLowerCase() : 'text';

  let composedSignal = composeSignals([signal, cancelToken && cancelToken.toAbortSignal()], timeout);

  let request;

  const unsubscribe = composedSignal && composedSignal.unsubscribe && (() => {
      composedSignal.unsubscribe();
  });

  let requestContentLength;

  try {
    if (
      onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' &&
      (requestContentLength = await resolveBodyLength(headers, data)) !== 0
    ) {
      let _request = new Request(url, {
        method: 'POST',
        body: data,
        duplex: "half"
      });

      let contentTypeHeader;

      if (utils$1.isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) {
        headers.setContentType(contentTypeHeader);
      }

      if (_request.body) {
        const [onProgress, flush] = progressEventDecorator(
          requestContentLength,
          progressEventReducer(asyncDecorator(onUploadProgress))
        );

        data = trackStream(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
      }
    }

    if (!utils$1.isString(withCredentials)) {
      withCredentials = withCredentials ? 'include' : 'omit';
    }

    // Cloudflare Workers throws when credentials are defined
    // see https://github.com/cloudflare/workerd/issues/902
    const isCredentialsSupported = "credentials" in Request.prototype;
    request = new Request(url, {
      ...fetchOptions,
      signal: composedSignal,
      method: method.toUpperCase(),
      headers: headers.normalize().toJSON(),
      body: data,
      duplex: "half",
      credentials: isCredentialsSupported ? withCredentials : undefined
    });

    let response = await fetch(request);

    const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');

    if (supportsResponseStream && (onDownloadProgress || (isStreamResponse && unsubscribe))) {
      const options = {};

      ['status', 'statusText', 'headers'].forEach(prop => {
        options[prop] = response[prop];
      });

      const responseContentLength = utils$1.toFiniteNumber(response.headers.get('content-length'));

      const [onProgress, flush] = onDownloadProgress && progressEventDecorator(
        responseContentLength,
        progressEventReducer(asyncDecorator(onDownloadProgress), true)
      ) || [];

      response = new Response(
        trackStream(response.body, DEFAULT_CHUNK_SIZE, onProgress, () => {
          flush && flush();
          unsubscribe && unsubscribe();
        }),
        options
      );
    }

    responseType = responseType || 'text';

    let responseData = await resolvers[utils$1.findKey(resolvers, responseType) || 'text'](response, config);

    !isStreamResponse && unsubscribe && unsubscribe();

    return await new Promise((resolve, reject) => {
      settle(resolve, reject, {
        data: responseData,
        headers: AxiosHeaders.from(response.headers),
        status: response.status,
        statusText: response.statusText,
        config,
        request
      });
    })
  } catch (err) {
    unsubscribe && unsubscribe();

    if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) {
      throw Object.assign(
        new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request),
        {
          cause: err.cause || err
        }
      )
    }

    throw AxiosError.from(err, err && err.code, config, request);
  }
});

const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter,
  fetch: fetchAdapter
};

utils$1.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

const renderReason = (reason) => `- ${reason}`;

const isResolvedHandle = (adapter) => utils$1.isFunction(adapter) || adapter === null || adapter === false;

const adapters = {
  getAdapter: (adapters) => {
    adapters = utils$1.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    const rejectedReasons = {};

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;

      adapter = nameOrAdapter;

      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

        if (adapter === undefined) {
          throw new AxiosError(`Unknown adapter '${id}'`);
        }
      }

      if (adapter) {
        break;
      }

      rejectedReasons[id || '#' + i] = adapter;
    }

    if (!adapter) {

      const reasons = Object.entries(rejectedReasons)
        .map(([id, state]) => `adapter ${id} ` +
          (state === false ? 'is not supported by the environment' : 'is not available in the build')
        );

      let s = length ?
        (reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0])) :
        'as no adapter specified';

      throw new AxiosError(
        `There is no suitable adapter to dispatch the request ` + s,
        'ERR_NOT_SUPPORT'
      );
    }

    return adapter;
  },
  adapters: knownAdapters
};

/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || defaults.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = AxiosHeaders.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = AxiosHeaders.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

const VERSION = "1.7.8";

const validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

validators$1.spelling = function spelling(correctSpelling) {
  return (value, opt) => {
    // eslint-disable-next-line no-console
    console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
    return true;
  }
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

const validator = {
  assertOptions,
  validators: validators$1
};

const validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy = {};

        Error.captureStackTrace ? Error.captureStackTrace(dummy) : (dummy = new Error());

        // slice off the Error: ... line
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
        try {
          if (!err.stack) {
            err.stack = stack;
            // match without the 2 top stack lines
          } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) {
            err.stack += '\n' + stack;
          }
        } catch (e) {
          // ignore the case where "stack" is an un-writable property
        }
      }

      throw err;
    }
  }

  _request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils$1.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }

    validator.assertOptions(config, {
      baseUrl: validators.spelling('baseURL'),
      withXsrfToken: validators.spelling('withXSRFToken')
    }, true);

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && utils$1.merge(
      headers.common,
      headers[config.method]
    );

    headers && utils$1.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = AxiosHeaders.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL$1(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  toAbortSignal() {
    const controller = new AbortController();

    const abort = (err) => {
      controller.abort(err);
    };

    this.subscribe(abort);

    controller.signal.unsubscribe = () => this.unsubscribe(abort);

    return controller.signal;
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils$1.isObject(payload) && (payload.isAxiosError === true);
}

const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new Axios(defaultConfig);
  const instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils$1.extend(instance, Axios.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils$1.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = CanceledError;
axios.CancelToken = CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = toFormData;

// Expose AxiosError class
axios.AxiosError = AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = AxiosHeaders;

axios.formToJSON = thing => formDataToJSON(utils$1.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters.getAdapter;

axios.HttpStatusCode = HttpStatusCode;

axios.default = axios;

var Method;
(function (Method) {
    Method["GET"] = "GET";
    Method["POST"] = "POST";
    Method["PUT"] = "PUT";
    Method["DELETE"] = "DELETE";
})(Method || (Method = {}));
let axiosInstance;
function initBrowserAxios() {
    if (axiosInstance) {
        return;
    }
    axiosInstance = axios.create({
        // 120 sec timeout
        timeout: 120000,
        // cap the maximum content length we'll accept to 600MBs, just in case
        maxContentLength: 30 * 20 * 1000 * 1000,
        // follow up to 10 HTTP 3xx redirects
        maxRedirects: 10,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });
}
const callAxios = async (config) => {
    try {
        const response = await axiosInstance.request(config);
        return response;
    }
    catch (error) {
        console.error(error);
        throw error;
    }
};

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

var noop_1 = noop;

const defaultPageLoadDataParams = [
    pageLoadDataParams.DIGITAL_PLATFORM,
    pageLoadDataParams.DIGITAL_PLATFORM_COUNTRY,
    pageLoadDataParams.ENVIRONMENT,
];
// eslint-disable-next-line @typescript-eslint/naming-convention
var pageLoadDataToAnalytics;
(function (pageLoadDataToAnalytics) {
    pageLoadDataToAnalytics["digitalPlatform"] = "digital_platform";
    pageLoadDataToAnalytics["digitalPlatformCountry"] = "digital_platform_country";
    pageLoadDataToAnalytics["environment"] = "environment";
})(pageLoadDataToAnalytics || (pageLoadDataToAnalytics = {}));

const isApc = Boolean(window.isApc);
const isBrowser = () => typeof window !== 'undefined';
const isV3 = () => Boolean(window.isV3);
const isPBS = () => Boolean(window.isPBS);
const isIndexDBEnabled = () => Boolean(window.isIndexDBEnabled);
const isPublicEnvironment = (isExecutedInBrowser = isBrowser) => {
    if (!isExecutedInBrowser())
        return false;
    if (window.isPublicPes)
        return true;
    try {
        return document.querySelector('body').getAttribute('is-public') === 'true';
    }
    catch (error) {
        console.warn('[PES]: Could not check if code is executed from Public Environment', error);
        return false;
    }
};
/**
 * Provides the country code and language code extracted from locale="lc_CC" attribute within body tag. The country code is transformed to lowercase when the function detects it is executed from the public environment.
 *
 * @param isExecutedInBrowser This optional parameter is the method to check if the code is executed in the browser. When is not passed, the function will use a default callback.
 * @returns An object containing country code and language code.
 */
const getLocaleFromBody = (isExecutedInBrowser) => {
    try {
        const locale = document.querySelector('body').getAttribute('locale');
        const [languageCode, rawContryCode] = locale.split('_');
        return {
            countryCode: isPublicEnvironment(isExecutedInBrowser)
                ? rawContryCode === null || rawContryCode === void 0 ? void 0 : rawContryCode.toLowerCase()
                : rawContryCode,
            languageCode,
        };
    }
    catch (error) {
        console.warn('[PES]: Could not get locale from body tag', error);
        return null;
    }
};
/**
 * Provides the country code and language code extracted from a URL passed as parameter. The country code is transformed to lowercase when the function detects it is executed from the public environment.
 *
 * @param url This mandatory parameter is the URL to extract the locale from. Examples: "https://www.se.com/es/es/product/tyreiuty/", "https://www.se.com//es/es/", "/es/es", "es/es", "https://www.schneider-electric.cn/zh/"
 * @param isExecutedInBrowser This optional parameter is the method to check if the code is executed in the browser. When is not passed, the function will use a default callback.
 * @returns An object containing country code and language code.
 */
const getLocaleFromURL = (url, isExecutedInBrowser) => {
    try {
        const [firstMatch, secondMatch] = url.replace(/^https?:\/\/[^/]+/, '')
            .replace(/^\/(apc)?(asco)?\/?/, '')
            .split('/');
        if (firstMatch === 'zh' || secondMatch === 'zh') {
            return {
                countryCode: isPublicEnvironment(isExecutedInBrowser) ? 'cn' : 'CN',
                languageCode: firstMatch === 'zh' ? firstMatch : secondMatch,
            };
        }
        return {
            countryCode: secondMatch,
            languageCode: firstMatch,
        };
    }
    catch (error) {
        console.warn(`[PES]: Could not get locale from URL provided: ${url}`, error);
        return null;
    }
};
const useReplatformedHMC = () => Boolean(window.isReplatformedHmc);
const productCartPageVersion = window.cartVersion;
const buildURL = ({ host, contextRoot, countryCode, languageCode, endpoint, }) => {
    let path = endpoint;
    if (languageCode) {
        path = `/${languageCode}${path}`;
    }
    if (countryCode) {
        /**
         * countryCode for China is
         * - lowercase (cn) if China-specific short-domain url is used as a host: 'https://schneider-electric.'
         *   which should be concatenated with countryCode without '/'
         * - uppercase (CN) if RP urls are used - in this case path should start with '/' symbol
         * Other countries' paths start with '/' symbol
         */
        path = `${countryCode !== 'cn' ? '/' : ''}${countryCode}${path}`;
    }
    if (contextRoot) {
        path = `${contextRoot}${path}`;
    }
    if (host) {
        path = `${host}${path}`;
    }
    return path;
};
const getSDLHeaderSelector = () => {
    if (isV3())
        return SDL_REDESIGN_HEADER_SELECTOR;
    // @ts-ignore
    if (window.isApc) {
        return SDL_HEADER_SELECTOR_APC;
    }
    return SDL_HEADER_SELECTOR;
};
const getHeaderHeight = () => {
    var _a, _b;
    return ((_b = (_a = document.querySelector(getSDLHeaderSelector())) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0);
};
const scrollToComponent = (el, options = {}) => {
    const { behavior = scrollBehavior.AUTO, offset = TAB_BAR_HEIGHT } = options;
    // A quick and dirty solution to the issue with scrolling to a component on sites of pes-catalog consumers:
    //  - MySe
    //  - MySchneider
    // See https://jira.se.com/browse/PESV3-27234 for details.
    if (document.querySelector(getSDLHeaderSelector())) {
        //  If there is the SDL header (we are on se.com or apc.com), we can scroll to the component while taking into account the header and the tabbar heights.
        const top = el.getBoundingClientRect().y + window.scrollY - getHeaderHeight() - offset;
        window.scrollTo({ top, behavior });
    }
    else {
        // If there is no header, we don't even try to guess the height of a consumer's header and just scroll the component into view.
        //  Most likely, it will be partially covered by the header, but we decided not to care about that for now.
        el.scrollIntoView();
    }
};
const consoleErrorMsg = (err, origin) => {
    console.error(`Error in ${origin}`, err);
};
const mergeUrlWithHost = (host, url) => {
    if ((host === null || host === void 0 ? void 0 : host.endsWith(SLASH)) && url.startsWith(SLASH)) {
        host.slice(0, host.length);
    }
    return `${host}${url}`;
};
const hasHttpOrHttps = (host) => {
    return host.includes(`${Protocol.HTTP}://`) || host.includes(`${Protocol.HTTPS}://`);
};
const validateHost = (host) => {
    return hasHttpOrHttps(host) ? host : '';
};
const tryParse = (data) => {
    try {
        return JSON.parse(data);
    }
    catch (e) {
        return data;
    }
};
const tryStringify = (data) => {
    try {
        return JSON.stringify(data);
    }
    catch (e) {
        return data;
    }
};
/**
 * Does object have any properties
 * @param {object} object
 */
const isEmpty = (object = {}) => Object.getOwnPropertyNames(object).length === 0;
const parseJsonResponse = (resp) => resp.json();
/**
 * Parse string and return defaultValue param if string cannot be parsed.
 */
const parseJSONString = (str, defaultValue) => {
    try {
        return JSON.parse(str);
    }
    catch (e) {
        return defaultValue;
    }
};
const isValidUrl = (url) => {
    try {
        // eslint-disable-next-line no-new
        new URL(url);
    }
    catch (_a) {
        return false;
    }
    return true;
};
const transformCamelCaseString = (string = '', delimeter = '') => {
    return string.replace(/([a-z0-9])([A-Z])/g, `$1${delimeter}$2`).toLowerCase();
};
/**
 * Merge target object and source object deeply, returning a target object with the elements from both target and source.
 * If an element at the same key is present for both target and source, the value from source will appear in the result.
 * Arrays are overwritten.
 * @param target
 * @param source
 */
// eslint-disable-next-line @typescript-eslint/default-param-last
const deepMerge = (target = {}, source) => {
    // eslint-disable-next-line no-restricted-syntax
    for (const key of Object.keys(source)) {
        if (Array.isArray(source[key])) {
            // eslint-disable-next-line no-param-reassign
            target[key] = [...source[key]];
        }
        else if (source[key] instanceof Object) {
            Object.assign(source[key], deepMerge(target[key], source[key]));
        }
    }
    Object.assign(target || {}, source);
    return target;
};
const getDataAttributes = (dataset) => {
    if (!dataset) {
        return {};
    }
    return Object.keys(dataset).reduce((acc, key) => {
        acc[`data-${transformCamelCaseString(key, '-')}`] = dataset[key];
        return acc;
    }, {});
};
const roundHalf = (num) => {
    return Math.round(num * 2) / 2;
};
const convertToPx = (...values) => {
    return values.map((val) => `${val}px`).join(' ');
};
const encodeProductId = (id) => encodeURIComponent(encodeURIComponent(id));
const isTargetBlank = (target) => target === '_blank';
const isLinkTypeOnline = (type) => type in ONLINE_CTA_TYPES;
const sendEvent = (type, data) => {
    const customEvent = new CustomEvent(type, {
        detail: data,
    });
    window.dispatchEvent(customEvent);
};
/**
 * Returns YouTube video ID from YouTube URL
 */
const getYouTubeVideoIDFromURL = (youTubeURL) => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = youTubeURL.match(regExp);
    return match && match[7].length === 11 ? match[7] : '';
};
const urlDecode = (encodedString) => decodeURIComponent(encodedString.replace(/\+/g, ' '));
var MediaGalleryImageExtensions;
(function (MediaGalleryImageExtensions) {
    MediaGalleryImageExtensions["SVG"] = ".svg";
})(MediaGalleryImageExtensions || (MediaGalleryImageExtensions = {}));
/**
 * Checks if the URL is an SVG image
*/
const isSVG = (url, isImage = false) => {
    if (!url)
        return false;
    try {
        const parsedUrl = new URL(url);
        const params = new URLSearchParams(parsedUrl.search);
        const fileName = params.get('p_File_Name'); // This key can be found in https://download.schneider-electric.com/files?p_enDocType=Offer+Marketing+Illustration&p_File_Name=Infographics_XALD_K_XB4_5_V2.svg&p_Doc_Ref=Infographics_XALD_K_XB4_5_V2
        if (fileName && isImage)
            return fileName.endsWith(MediaGalleryImageExtensions.SVG) && isImage;
        return url.endsWith(MediaGalleryImageExtensions.SVG);
    }
    catch (error) {
        console.warn(error);
        return false;
    }
};
const isUrl = (url) => {
    if (!url)
        return false;
    try {
        new URL(url);
        return true;
    }
    catch (error) {
        // eslint-disable-next-line no-useless-escape
        if (/\/[^\/]+\.\w+$/.test(url)) { // this line of code is used to handle the case where the url is a relative path and ends with any image extensions'
            return true;
        }
        console.warn(error);
        return false;
    }
};
const getCTAClickEventParams = (name, category, url, position) => {
    return {
        cta_location: position || '',
        cta_name: name || '',
        cta_category: category || '',
        cta_link: url || '',
    };
};
function arrayToMap(items, key) {
    const itemMap = new Map();
    items.forEach((item) => {
        const mapKey = item[key];
        if (mapKey === undefined || mapKey === null)
            return;
        itemMap.set(mapKey, item);
    });
    return itemMap;
}
/**
 * Generate alphanumerical hash of specified length.
 */
const makeId = (length = 5) => {
    let text = '';
    const possible = 'abcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < length; i += 1) {
        /* NOSONAR_BEGIN */
        text += possible.charAt(Math.floor(Math.random() * possible.length));
        /* NOSONAR_END */
    }
    return text;
};
const COMPARATOR_LOCALE = document.documentElement.lang.replace('-', '_');
const sleep = (ms = 0) => new Promise((res) => {
    setTimeout(res, ms);
});
const allFinished = (promisesArray) => Promise.all(promisesArray.map((promise) => promise.catch(noop_1)));
/**
 * Retrieves sessionId from storage if exists. Else generates new sessionId.
 */
const getComparisonSessionId = () => {
    const seSessionId = 'COMPARISON_SESSION_ID';
    const apcSessionId = 'APC_COMPARISON_SESSION_ID';
    const COMPARISON_SESSION_ID = !isApc ? seSessionId : apcSessionId;
    let sessionId = localStorage.getItem(COMPARISON_SESSION_ID);
    if (!sessionId) {
        sessionId = makeId();
        localStorage.setItem(COMPARISON_SESSION_ID, sessionId);
    }
    return sessionId;
};
const getComparatorThreshold = () => {
    const comparatorThreshold = parseInt(window.comparatorThreshold);
    return Number.isNaN(comparatorThreshold) ? undefined : comparatorThreshold;
};
const getStorageComparatorName = () => {
    if (!isApc) {
        return `pesProductComparisonList_${COMPARATOR_LOCALE}`;
    }
    return 'comparisonList';
};
const MAX_COMPARATOR_ITEMS = getComparatorThreshold();
const BACK_TO_RESULTS_LINK = 'pesBackLink';
const STORAGE_COMPARATOR_NAME = getStorageComparatorName();
const PRODUCT_IDS_SEPARATOR = ',';
class Comparator {
    constructor() {
        this.handleCompareControlClick = (event) => {
            const productId = typeof event.detail === 'string' ? event.detail : event.detail.repositoryId;
            if (this.has(productId)) {
                this.remove(productId);
            }
            else if (!this.isFull()) {
                this.add(productId);
            }
            else {
                return;
            }
            this.notifySubscribers();
        };
        this.handleStorageChange = (event) => {
            if (event.key === STORAGE_COMPARATOR_NAME) {
                this.notifySubscribers();
            }
        };
        this.setListeners();
        if (!isApc) {
            this.setBackLink();
        }
    }
    setListeners() {
        window.addEventListener(EEvent.COMPARE_CONTROL_CLICK, this.handleCompareControlClick);
        window.addEventListener('storage', this.handleStorageChange);
    }
    setBackLink() {
        const currentURL = window.location.href;
        const isComparatorPage = currentURL.includes('/product-comparator/');
        if (!isComparatorPage) {
            window.localStorage.setItem(`${COMPARATOR_LOCALE}-${BACK_TO_RESULTS_LINK}`, currentURL);
        }
    }
    getBackLink() {
        return window.localStorage.getItem(`${COMPARATOR_LOCALE}-${BACK_TO_RESULTS_LINK}`) || '';
    }
    getStoredProductIds() {
        var _a;
        const serializedList = (_a = localStorage.getItem(STORAGE_COMPARATOR_NAME)) !== null && _a !== void 0 ? _a : '';
        if (!isApc) {
            return serializedList.split(PRODUCT_IDS_SEPARATOR).filter(Boolean);
        }
        let result = [];
        try {
            result = JSON.parse(serializedList);
        }
        finally {
            /* NOSONAR_BEGIN */
            // eslint-disable-next-line no-unsafe-finally
            return result;
            /* NOSONAR_END */
        }
    }
    store(productIds) {
        let serializedList;
        if (!isApc) {
            serializedList = productIds.join(PRODUCT_IDS_SEPARATOR);
        }
        else {
            serializedList = JSON.stringify(productIds);
        }
        localStorage.setItem(STORAGE_COMPARATOR_NAME, serializedList);
    }
    has(productId) {
        return this.getStoredProductIds().includes(productId);
    }
    add(productId) {
        const productIds = [...this.getStoredProductIds(), productId];
        this.store(productIds);
    }
    remove(productId) {
        const productIds = this.getStoredProductIds();
        this.store(productIds.filter((id) => productId !== id));
    }
    isFull() {
        if (MAX_COMPARATOR_ITEMS) {
            return this.getStoredProductIds().length >= MAX_COMPARATOR_ITEMS;
        }
        return false;
    }
    get value() {
        return {
            list: this.getStoredProductIds(),
            isFull: this.isFull(),
            productProp: 'repositoryId',
        };
    }
    notifySubscribers() {
        sendEvent(EEvent.COMPARATOR_PRODUCTS_CHANGE, this.value);
    }
    removeAll() {
        localStorage.removeItem(STORAGE_COMPARATOR_NAME);
        this.notifySubscribers();
    }
}
const comparator = new Comparator();
const getComparatorUrl = (baseUrl) => {
    const productIds = comparator.getStoredProductIds().join('|');
    return `${baseUrl}/${getComparisonSessionId()}/${productIds}/`;
};
const getSlottedContent = (slot) => {
    let slottedContentElement = null;
    if (slot) {
        while (!slottedContentElement || slottedContentElement.nodeName === 'SLOT') {
            if (slot.assignedElements().length) {
                if (slot.assignedElements()[0].nodeName === 'SLOT') {
                    // eslint-disable-next-line no-param-reassign
                    slot = slot.assignedElements()[0];
                }
                else {
                    // eslint-disable-next-line prefer-destructuring
                    slottedContentElement = slot.assignedElements()[0];
                }
            }
            else {
                break;
            }
        }
    }
    return slottedContentElement;
};
const getProductCtasLabels = ({ labels = {}, }) => {
    const { addToCartLabel, removeFromCartLabel, addToMyProductsLabel, removeFromMyProductsLabel, } = labels;
    return {
        addToCartLabel,
        removeFromCartLabel,
        addToMyProductsLabel,
        removeFromMyProductsLabel,
    };
};
const addPageLoadDataInfoToAnalyticsEvent = (params = defaultPageLoadDataParams) => {
    var _a;
    const pageLoadData = (_a = window === null || window === void 0 ? void 0 : window.pesAnalytics) === null || _a === void 0 ? void 0 : _a.pageLoadData;
    return pageLoadData
        ? params.reduce((acc, curr) => {
            if (Object.getOwnPropertyDescriptor(pageLoadData, curr)) {
                acc[pageLoadDataToAnalytics[curr]] = pageLoadData[curr];
            }
            return acc;
        }, {})
        : {};
};

const getBrandName = () => {
    if (window.isAsco)
        return 'ascopower';
    if (window.isApc)
        return 'apc';
    return 'se';
};
// China is a special case — its "country code" comes from the hostname
// TODO: reuse in comparison app
const isHostnameContainsCC = () => {
    return window.location.hostname.toLowerCase().endsWith('cn');
};
const getBodyLanguageCode = () => {
    var _a;
    return ((_a = document.body.getAttribute('locale').split('_')[0]) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) || '';
};
const getBodyCountryCode = () => {
    var _a;
    return ((_a = document.body.getAttribute('locale').split('_')[1]) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) || '';
};
const buildStorageName = () => {
    const brand = getBrandName();
    return `${brand}/${getBodyCountryCode()}/${getBodyLanguageCode()}`;
};
const getConsumerSpecificData = (isPBS, specificStorageName) => {
    return {
        storageName: isPBS ? specificStorageName : buildStorageName(),
        consumer: isPBS ? ClientApps.PBS : ClientApps.PPW,
    };
};
const buildLocaleCode = ({ countryCode, languageCode, }) => {
    return `${countryCode}/${languageCode}`;
};
const formatToLocaleString = (amount, locale) => {
    return new Intl.NumberFormat(locale).format(amount);
};
const transformLocaleToBCP47LanguageTag = (locale) => {
    const ERROR_MESSAGE = 'Invalid locale format';
    if (!/^[a-z]{2}-[A-Z]{2}$/.test(locale)) {
        throw new Error(ERROR_MESSAGE);
    }
    const [languageCode] = /^[a-z]{2}/.exec(locale);
    const [countryCode] = /[A-Z]{2}$/.exec(locale);
    if (!languageCode || !countryCode) {
        throw new Error(ERROR_MESSAGE);
    }
    return `${languageCode}-${countryCode}`;
};

const getCommerceConnectorEndpointUrl = ({ host = '', contextRoot, countryCode, languageCode, }) => {
    if (isV3()) {
        return `${host}${SPRYKER_COMMERCE_CONNECTOR_PATH}`;
    }
    return buildURL({
        host,
        contextRoot,
        countryCode,
        languageCode,
        endpoint: ATG_COMMERCE_CONNECTOR_PATH,
    });
};
const commerceConnectorApiFetchers = {
    getCommerceConnector: async ({ host, contextRoot, countryCode, languageCode, }) => {
        const GET_COMMERCE_CONNECTOR_URL = getCommerceConnectorEndpointUrl({
            host,
            contextRoot,
            countryCode,
            languageCode,
        });
        const requestSettings = {
            method: Method.GET,
            url: GET_COMMERCE_CONNECTOR_URL,
        };
        if (isV3()) {
            requestSettings.params = {
                'country-code': countryCode,
                'language-code': languageCode,
                brand: getBrandName(),
            };
        }
        const response = await callAxios(requestSettings);
        return response.data;
    },
};

const getMyProductsCrudUrl = ({ contextRoot, countryCode, languageCode, urlRequestMethod, id, }) => {
    let myProductsRequestUrl = '';
    if (contextRoot) {
        // eslint-disable-next-line no-param-reassign
        contextRoot = `/${contextRoot}`;
    }
    switch (urlRequestMethod) {
        case 'getOrPost':
            myProductsRequestUrl = isV3() && productCartPageVersion === CartVersion.v3
                ? SPRYKER_MY_PRODUCTS_REST_URL
                : buildURL({
                    host: '',
                    contextRoot,
                    countryCode,
                    languageCode,
                    endpoint: ATG_MY_PRODUCTS_REST_URL,
                });
            break;
        case 'getByIdOrDelete':
            myProductsRequestUrl = isV3() && productCartPageVersion === CartVersion.v3
                ? `${SPRYKER_MY_PRODUCTS_REST_URL}/${id}`
                : buildURL({
                    host: '',
                    contextRoot,
                    countryCode,
                    languageCode,
                    endpoint: `${ATG_MY_PRODUCTS_REST_URL}/${id}`,
                });
            break;
        default:
            myProductsRequestUrl = isV3() && productCartPageVersion === CartVersion.v3
                ? SPRYKER_MY_PRODUCTS_REST_URL
                : buildURL({
                    host: '',
                    contextRoot,
                    countryCode,
                    languageCode,
                    endpoint: ATG_MY_PRODUCTS_REST_URL,
                });
    }
    return myProductsRequestUrl;
};
const myProductsApiFetchers = {
    postMyProducts: async ({ contextRoot, countryCode, languageCode, payload, }) => {
        const urlRequestMethod = 'getOrPost';
        const POST_MY_PRODUCTS_URL = getMyProductsCrudUrl({
            contextRoot,
            countryCode,
            languageCode,
            urlRequestMethod,
        });
        const requestSettings = {
            method: Method.POST,
            url: POST_MY_PRODUCTS_URL,
            withCredentials: true,
            data: payload,
        };
        if (isV3() && productCartPageVersion === CartVersion.v3) {
            requestSettings.params = {
                'country-code': countryCode,
                'language-code': languageCode,
                brand: getBrandName(),
            };
        }
        const response = await callAxios(requestSettings);
        return response.data;
    },
    getMyProducts: async ({ contextRoot, countryCode, languageCode, params, }) => {
        const urlRequestMethod = 'getOrPost';
        const API_GET_MY_PRODUCTS = getMyProductsCrudUrl({
            contextRoot,
            countryCode,
            languageCode,
            urlRequestMethod,
        });
        const requestSettings = {
            method: Method.GET,
            url: API_GET_MY_PRODUCTS,
            withCredentials: true,
        };
        if (isV3() && productCartPageVersion === CartVersion.v3) {
            requestSettings.params = Object.assign({ 'country-code': countryCode, 'language-code': languageCode, brand: getBrandName() }, params);
        }
        else {
            requestSettings.params = params;
        }
        const response = await callAxios(requestSettings);
        return response.data;
    },
    deleteMyProducts: async ({ contextRoot, countryCode, languageCode, params: { id }, }) => {
        const urlRequestMethod = 'getByIdOrDelete';
        const API_DELETE_MY_PRODUCTS = getMyProductsCrudUrl({
            contextRoot,
            countryCode,
            languageCode,
            urlRequestMethod,
            id,
        });
        const requestSettings = {
            method: Method.DELETE,
            url: API_DELETE_MY_PRODUCTS,
            withCredentials: true,
        };
        if (isV3() && productCartPageVersion === CartVersion.v3) {
            requestSettings.params = {
                'country-code': countryCode,
                'language-code': languageCode,
                brand: getBrandName(),
            };
        }
        const response = await callAxios(requestSettings);
        return response.data;
    },
};

const getProductCardMainEndpointUrl = ({ contextRoot, countryCode, languageCode, }) => {
    if (isV3())
        return SPRYKER_PRODUCT_CARD_MAIN_PATH;
    return buildURL({
        host: '',
        contextRoot,
        countryCode,
        languageCode,
        endpoint: ATG_PRODUCT_CARD_MAIN_PATH,
    });
};
const productsApiFetchers = {
    getProductsFetcher: async ({ contextRoot, countryCode, languageCode, params, }) => {
        const GET_PRODUCTS_URL = getProductCardMainEndpointUrl({
            contextRoot,
            countryCode,
            languageCode,
        });
        const requestSettings = {
            method: Method.GET,
            url: GET_PRODUCTS_URL,
        };
        if (isV3()) {
            requestSettings.params = Object.assign({ 'country-code': countryCode, 'language-code': languageCode, brand: getBrandName() }, params);
        }
        else {
            requestSettings.params = params;
        }
        const response = await callAxios(requestSettings);
        return response.data;
    },
};

const getTranslationURL$1 = (contextRoot, countryCode, languageCode) => {
    if (process_1.env.REACT_APP_DEV === 'mock')
        return 'http://localhost:3100/get-products-parameters';
    const brand = getBrandName();
    if (isV3()) {
        return buildURL({
            host: process_1.env.API_HOST,
            endpoint: `/products-comparison/characteristics?country-code=${countryCode}&language-code=${languageCode}&brand=${brand}`,
        });
    }
    return buildURL({
        host: process_1.env.API_HOST,
        contextRoot,
        countryCode,
        languageCode,
        endpoint: '/product/api/products/comparison/characteristics',
    });
};
const productsParametersApiFetchers = {
    getProductsParametersFetcher: async ({ contextRoot, countryCode, languageCode, params, }) => {
        const GET_PRODUCTS_PARAMETERS_URL = getTranslationURL$1(contextRoot, countryCode, languageCode);
        const response = await callAxios({
            method: Method.GET,
            url: GET_PRODUCTS_PARAMETERS_URL,
            params,
        });
        return response.data;
    },
};

const getProductInfoEndpointUrl = ({ contextRoot, countryCode, languageCode, }) => {
    if (isV3())
        return SPRYKER_PRODUCT_CARD_SECONDARY_PATH;
    return buildURL({
        host: '',
        contextRoot,
        countryCode,
        languageCode,
        endpoint: ATG_PRODUCT_CARD_ADDITION_PATH,
    });
};
const productsInfoApiFetchers = {
    getProductsInfoFetcher: async ({ contextRoot, countryCode, languageCode, params, }) => {
        const GET_PRODUCTS_INFO_URL = getProductInfoEndpointUrl({
            contextRoot,
            countryCode,
            languageCode,
        });
        const requestSettings = {
            method: Method.GET,
            url: GET_PRODUCTS_INFO_URL,
        };
        if (isV3()) {
            requestSettings.params = Object.assign({ 'country-code': countryCode, 'language-code': languageCode, brand: getBrandName() }, params);
        }
        else {
            requestSettings.params = params;
        }
        const response = await callAxios(requestSettings);
        return response.data;
    },
};

const getTranslationURL = (contextRoot, languageCode, countryCode) => {
    const brand = getBrandName();
    if (process_1.env.REACT_APP_DEV === 'mock')
        return 'http://localhost:3100/get-translations';
    if (isV3()) {
        return buildURL({
            host: process_1.env.API_HOST,
            endpoint: `/products-comparison/main?country-code=${countryCode}&language-code=${languageCode}&brand=${brand}`,
        });
    }
    return buildURL({
        host: process_1.env.API_HOST,
        contextRoot,
        countryCode,
        languageCode,
        endpoint: '/product/api/products/comparison/main',
    });
};
const translationsApiFetchers = {
    getTranslationsFetcher: async ({ contextRoot, countryCode, languageCode, params = { content: 'labels' }, }) => {
        const GET_TRANSLATIONS_URL = getTranslationURL(contextRoot, languageCode, countryCode);
        const response = await callAxios({
            method: Method.GET,
            url: GET_TRANSLATIONS_URL,
            params,
        });
        return response.data;
    },
};

const channelSightApiFetchers = {
    getProductsDataFeed: async ({ params }) => {
        const GET_PRODUCTS_FEED_URL = `${params.feedUrl}&pid=${params.productIds}`;
        const response = await callAxios({
            method: Method.GET,
            url: GET_PRODUCTS_FEED_URL,
        });
        return response.data;
    },
};

const bazaarVoiceApiFetchers = {
    getBazaarVoiceFetcher: async (params) => {
        const GET_BAZAARVOICE_URL = process_1.env.REACT_APP_DEV === 'mock'
            ? 'http://localhost:3100/get-bazaar-voice'
            : `${BAZAAR_VOICE_URL}?${params}`;
        const response = await callAxios({
            method: Method.GET,
            url: GET_BAZAARVOICE_URL,
        });
        return response.data;
    },
};

const productAvailabilityApiFetchers = {
    getProductAvailabilityFetcher: async ({ apcHost, params, }) => {
        const GET_PRODUCT_AVAILABILITY_URL = process_1.env.REACT_APP_DEV === 'mock'
            ? 'http://localhost:3100/get-product-availability'
            : buildURL({
                host: process_1.env.API_HOST,
                contextRoot: apcHost,
                endpoint: '/rest/model/schneider/catalog/availability/rest/ProductAvailabilityActor/pdpProductAvailabilityInfo',
            });
        const response = await callAxios({
            method: Method.GET,
            url: GET_PRODUCT_AVAILABILITY_URL,
            params,
        });
        return response.data;
    },
};

const buildCtaUrl = ({ contextRoot, countryCode, languageCode }) => {
    if (isV3()) {
        const endPoint = '/products-cta';
        const queryParams = `?country-code=${countryCode}&language-code=${languageCode}&brand=${getBrandName()}`;
        const url = endPoint + queryParams;
        return url;
    }
    return buildURL({
        host: process_1.env.API_HOST,
        contextRoot,
        countryCode,
        languageCode,
        endpoint: '/product/api/commerce-api/cta',
    });
};
const apcCtaApiFetchers = {
    getApcCtaFetcher: async ({ contextRoot, countryCode, languageCode }) => {
        const GET_APC_CTA_URL = process_1.env.REACT_APP_DEV === 'mock'
            ? 'http://localhost:3100/get-apc-cta'
            : buildCtaUrl({ contextRoot, countryCode, languageCode });
        const response = await callAxios({
            method: Method.GET,
            url: GET_APC_CTA_URL,
        });
        return response.data;
    },
};

const getAnalyticsLookupsEndpointUrl = ({ host, countryCode, languageCode, }) => {
    if (isV3())
        return `${host}${SPRYKER_ANALYTICS_LOOKUPS}`;
    return buildURL({
        host,
        countryCode,
        languageCode,
        endpoint: ATG_ANALYTICS_LOOKUPS,
    });
};
const analyticsApiFetchers = {
    getAnalyticsLookupFetcher: async ({ host, countryCode, languageCode }) => {
        const GET_PRODUCTS_INFO_URL = getAnalyticsLookupsEndpointUrl({
            host,
            countryCode,
            languageCode,
        });
        const requestSettings = {
            method: Method.GET,
            url: GET_PRODUCTS_INFO_URL,
        };
        if (isV3()) {
            requestSettings.params = {
                brand: getBrandName(),
                'country-code': countryCode,
                'language-code': languageCode,
            };
        }
        const response = await callAxios(requestSettings);
        return response.data;
    },
};

const getComparisonBundleURL = (contextRoot, languageCode, countryCode) => {
    const brand = getBrandName();
    if (isV3()) {
        return buildURL({
            host: process_1.env.API_HOST,
            endpoint: `/products-comparison/main?country-code=${countryCode}&language-code=${languageCode}&brand=${brand}`,
        });
    }
    return buildURL({
        host: process_1.env.API_HOST,
        contextRoot,
        countryCode,
        languageCode,
        endpoint: '/product/api/products/comparison/main',
    });
};
const comparisonBundleProductsApiFetchers = {
    getComparisonBundleProductsFetcher: async ({ contextRoot, countryCode, languageCode, params, }) => {
        const GET_COMPARISON_BUNDLE_PRODUCTS = getComparisonBundleURL(contextRoot, languageCode, countryCode);
        const response = await callAxios({
            method: Method.GET,
            url: GET_COMPARISON_BUNDLE_PRODUCTS,
            params,
        });
        return response.data;
    },
};

const ctaShoppableApiFetchers = {
    getShopSeRedirectionLink: async ({ url, query, store }) => {
        try {
            const response = await callAxios({
                method: Method.POST,
                url,
                data: { query },
                headers: {
                    store,
                },
            });
            return { result: response.data, error: null };
        }
        catch (error) {
            return { result: null, error };
        }
    },
};

const substitutionProductsApiFetchers = {
    getSubstitutionProducts: async ({ countryCode, languageCode, params, }) => {
        const requestSettings = {
            method: Method.GET,
            url: SPRYKER_PRODUCTS_SUBSTITUTION,
            params: Object.assign({ 'country-code': countryCode, 'language-code': languageCode, brand: getBrandName() }, params),
        };
        try {
            const response = await callAxios(requestSettings);
            return { productSubstitutionsResponse: response.data, error: null };
        }
        catch (error) {
            return { productSubstitutionsResponse: null, error };
        }
    },
};

const relatedProductsApiFetchers = {
    getRelatedProducts: async ({ countryCode, languageCode, productId, }) => {
        const GET_RELATED_PRODUCTS_URL = `/products/${productId}/related-products`;
        const requestSettings = {
            method: Method.GET,
            url: GET_RELATED_PRODUCTS_URL,
            params: {
                brand: getBrandName(),
                'country-code': countryCode,
                'language-code': languageCode,
            },
        };
        try {
            const response = await callAxios(requestSettings);
            return { relatedProductsResponse: response.data, error: null };
        }
        catch (error) {
            return { relatedProductsResponse: null, error };
        }
    },
};

initBrowserAxios();
const fetchers = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, productsApiFetchers), productsParametersApiFetchers), productsInfoApiFetchers), translationsApiFetchers), myProductsApiFetchers), commerceConnectorApiFetchers), channelSightApiFetchers), bazaarVoiceApiFetchers), productAvailabilityApiFetchers), apcCtaApiFetchers), analyticsApiFetchers), comparisonBundleProductsApiFetchers), ctaShoppableApiFetchers), substitutionProductsApiFetchers), relatedProductsApiFetchers);

var _a;
let lookups = (_a = window === null || window === void 0 ? void 0 : window.pesAnalytics) === null || _a === void 0 ? void 0 : _a.lookups;
const getLookup = (host, cc, lc) => {
    fetchers
        .getAnalyticsLookupFetcher({
        host,
        countryCode: cc,
        languageCode: lc,
    })
        .then((data) => {
        lookups = data;
    })
        .catch((err) => {
        console.error(err);
    });
};
const getLookupValueFunction = (lookupKey) => {
    return (key, id) => {
        if (!lookups) {
            return '';
        }
        let value = lookups[lookupKey][key] || '';
        if (id) {
            value = `${value.split(':')[0]}:${id}`;
        }
        return value;
    };
};
const getLookupValueAddCartLocation = getLookupValueFunction('addCartLocation');
const getLookupValueAddCartCTAType = getLookupValueFunction('addCartCTAType');
const getLookupValueProductLists = getLookupValueFunction('productLists');
const getLookupValueVirtualPageType = getLookupValueFunction('virtualPageTypes');
const getLookupValueVirtualPageName = getLookupValueFunction('virtualPageName');
const getLookupValuePageTabs = getLookupValueFunction('pageTabs');

var FileSaver_min = createCommonjsModule(function (module, exports) {
(function(a,b){b();})(commonjsGlobal,function(){function b(a,b){return "undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(a,b,c){var d=new XMLHttpRequest;d.open("GET",a),d.responseType="blob",d.onload=function(){g(d.response,b,c);},d.onerror=function(){console.error("could not download file");},d.send();}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send();}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"));}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b);}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof commonjsGlobal&&commonjsGlobal.global===commonjsGlobal?commonjsGlobal:void 0,a=f.navigator&&/Macintosh/.test(navigator.userAgent)&&/AppleWebKit/.test(navigator.userAgent)&&!/Safari/.test(navigator.userAgent),g=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype&&!a?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href);},4E4),setTimeout(function(){e(j);},0));}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else {var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i);});}}:function(b,d,e,g){if(g=g||open("","_blank"),g&&(g.document.title=g.document.body.innerText="downloading..."),"string"==typeof b)return c(b,d,e);var h="application/octet-stream"===b.type,i=/constructor/i.test(f.HTMLElement)||f.safari,j=/CriOS\/[\d]+/.test(navigator.userAgent);if((j||h&&i||a)&&"undefined"!=typeof FileReader){var k=new FileReader;k.onloadend=function(){var a=k.result;a=j?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),g?g.location.href=a:location=a,g=null;},k.readAsDataURL(b);}else {var l=f.URL||f.webkitURL,m=l.createObjectURL(b);g?g.location=m:location.href=m,g=null,setTimeout(function(){l.revokeObjectURL(m);},4E4);}});f.saveAs=g.saveAs=g,(module.exports=g);});

//# sourceMappingURL=FileSaver.min.js.map
});

class ExcelService {
    constructor(excelSettings) {
        this.settings = {
            mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            extension: '.xlsx',
        };
        Object.assign(this.settings, excelSettings);
    }
    async getExcelJS() {
        try {
            if (!this.excelJSInstance)
                this.excelJSInstance = await window.System.import('exceljs');
            return { excelJS: this.excelJSInstance, error: null };
        }
        catch (error) {
            consoleErrorMsg(error, 'ExcelService -> getExcelJS');
            return { excelJS: null, error };
        }
    }
    // Order in values matters
    makeSingleItemRow(values, config) {
        const { emptyColumns, totalColumns, filler } = config;
        const cells = [];
        for (let index = 0; index < totalColumns; index++) {
            if (emptyColumns.includes(index) || index > values.length)
                cells.push(filler);
            else
                cells.push(values[index] || ' ');
        }
        return cells;
    }
    // Mutates worksheet
    hideEmptyColumns(worksheet) {
        const columns = worksheet.columnCount;
        for (let index = 1; index <= columns; index++) {
            let notEmpty = false;
            const eColumn = worksheet.getColumn(index);
            if (eColumn.hidden)
                continue;
            eColumn.eachCell({ includeEmpty: true }, (cell, rowNumber) => {
                if (rowNumber > 1 && String(cell.value).trim() !== '') {
                    notEmpty = true;
                }
            });
            eColumn.hidden = !notEmpty;
        }
    }
    // Mutates row
    populateRow(rowValues, row) {
        rowValues.forEach((value, index) => {
            // eslint-disable-next-line no-param-reassign
            row.getCell(index + 1).value = value;
        });
        return row;
    }
    async saveExcel(workbook, fileName) {
        try {
            const excelData = await workbook.xlsx.writeBuffer();
            const excelFile = new Blob([excelData], { type: this.settings.mimeType });
            FileSaver_min.saveAs(excelFile, fileName + this.settings.extension);
        }
        catch (error) {
            consoleErrorMsg(error, 'ExcelService -> saveExcel');
        }
    }
}
const ExcelJSService = new ExcelService();

// check if breadcrumbs are valid, validation for PBS and PPW is different
const areBreadcrumbsLevelsValid = (breadcrumbs, key, breadcrumbsType) => {
    if (!(breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length)) {
        return false;
    }
    const currentPageType = key === null || key === void 0 ? void 0 : key.split('/')[0];
    const breadcrumbsTypes = breadcrumbsLevels[breadcrumbsType];
    const endIndex = breadcrumbsTypes.indexOf(currentPageType);
    const updatedBreadcrumb = breadcrumbsTypes.slice(0, endIndex || 1);
    return updatedBreadcrumb.every((breadcrumbType, breadcrumbTypeIndex) => {
        return (breadcrumbs[breadcrumbTypeIndex]
            && breadcrumbs[breadcrumbTypeIndex].itemType === breadcrumbType);
    });
};
// When breadcrumbs item is pressed, function finds an index of this,
//  cut breadcrumbs after that item and return updated breadcrumb
const filterBreadcrumbsForSaving = (arr, itemType) => {
    const index = arr.findIndex((obj) => obj.itemType === itemType);
    return index !== -1 ? arr.slice(0, index + 1) : [];
};

class IndexDBService {
    constructor() {
        this.databaseInstance = null;
        // should be set at first to create channel for working with indexDB
        this.setChannel = (channel) => {
            this.channel = channel;
        };
        // handle connection success, error, onupgradeneeded methods
        this.createDBOperationListeners = (dbOperation) => {
            return new Promise((resolve, reject) => {
                if (!dbOperation) {
                    reject(new Error('DB Connection error'));
                }
                // eslint-disable-next-line no-param-reassign
                dbOperation.onerror = async (event) => {
                    console.warn(event);
                    reject(event);
                };
                // eslint-disable-next-line no-param-reassign
                dbOperation.onsuccess = async (event) => {
                    this.databaseInstance = event.target.result;
                    resolve(event);
                };
            });
        };
        // set connection with database
        this.connectDataBase = (newVersion) => {
            const connect = indexedDB === null || indexedDB === void 0 ? void 0 : indexedDB.open(this.channel, newVersion);
            return this.createDBOperationListeners(connect);
        };
        // Check if lines count in database more than max_count, sort by added date and delete redundant
        this.deleteOldRecords = async (count, store) => {
            if (count <= MAX_BREADCRUMBS_RECORDS_COUNT) {
                return;
            }
            const index = store.index(INDEXDB_CREATION_KEY);
            const getAllRequest = index.getAll();
            await this.createDBOperationListeners(getAllRequest);
            const sortedRecords = [...getAllRequest.result].sort((a, b) => b.addedAt - a.addedAt);
            const recordsToKeep = sortedRecords.slice(0, MAX_BREADCRUMBS_RECORDS_COUNT);
            // eslint-disable-next-line no-param-reassign
            store.openCursor().onsuccess = (event) => {
                const cursor = event.target.result;
                if (!cursor) {
                    console.error('Cursor is not found');
                    return;
                }
                if (!recordsToKeep.find((record) => record.addedAt === cursor.value.addedAt)) {
                    cursor.delete();
                }
                cursor.continue();
            };
            // eslint-disable-next-line no-param-reassign
            store.openCursor().onerror = (event) => {
                console.error(event);
            };
        };
        // connect database , find necessary storage, check count of records and delete old records
        this.keepLatestRecords = async (storageName) => {
            await this.connectDataBase();
            const transaction = this.databaseInstance.transaction(storageName, 'readwrite');
            const store = transaction.objectStore(storageName);
            const countStoreConnect = store.count();
            const countStoreConnectEvent = await this.createDBOperationListeners(countStoreConnect);
            const recordsCount = countStoreConnectEvent.target.result;
            await this.deleteOldRecords(Number(recordsCount), store);
        };
        // setting new storage in the channel
        this.setNewStorage = async ({ storageName, dataToInsert, key, }) => {
            if (this.databaseInstance) {
                this.databaseInstance.close();
            }
            const newVersion = this.databaseInstance.version + 1;
            const connect = indexedDB === null || indexedDB === void 0 ? void 0 : indexedDB.open(this.channel, newVersion);
            connect.onupgradeneeded = (event) => {
                this.databaseInstance = event.target.result;
                const objectStore = this.databaseInstance.createObjectStore(storageName, { autoIncrement: false });
                objectStore.createIndex(INDEXDB_CREATION_KEY, INDEXDB_CREATION_KEY, { unique: false });
            };
            await this.createDBOperationListeners(connect);
            const transaction = this.databaseInstance.transaction(storageName, 'readwrite');
            const store = transaction.objectStore(storageName);
            const addConnect = store.add({ data: dataToInsert, addedAt: new Date().getTime() }, key);
            await this.createDBOperationListeners(addConnect);
        };
        // adding data to existing storage
        this.addToStorage = async ({ storageName, objectToAdd, key, }) => {
            await this.connectDataBase();
            const transaction = this.databaseInstance.transaction(storageName, 'readwrite');
            const store = transaction.objectStore(storageName);
            const addConnection = store.add({ data: objectToAdd, addedAt: new Date().getTime() }, key);
            await this.createDBOperationListeners(addConnection);
            await this.keepLatestRecords(storageName);
            return objectToAdd;
        };
        // get data from existing storage
        this.getFromStorage = async ({ storageName, key, }) => {
            await this.connectDataBase();
            const transaction = this.databaseInstance.transaction(storageName, 'readonly');
            const store = transaction.objectStore(storageName);
            const getRequestConnection = store.get(key);
            const getRequestConnectionEvent = await this.createDBOperationListeners(getRequestConnection);
            const { data } = getRequestConnectionEvent.target.result || {};
            return data;
        };
        // check if key exist in the storage
        this.checkKeyExisting = async (storageName, key) => {
            await this.connectDataBase();
            const transaction = this.databaseInstance.transaction(storageName, 'readonly');
            const objectStore = transaction.objectStore(storageName);
            const storageConnect = objectStore.get(key);
            const storageConnectEvent = await this.createDBOperationListeners(storageConnect);
            const { result } = storageConnectEvent.target;
            return !!result;
        };
        this.checkStorageExisting = (storageName) => {
            if (!this.databaseInstance)
                return;
            return this.databaseInstance.objectStoreNames.contains(storageName);
        };
        // update data in storage
        this.updateStorage = async ({ storageName, key, newData }) => {
            await this.connectDataBase();
            const transaction = this.databaseInstance.transaction(storageName, 'readwrite');
            const store = transaction.objectStore(storageName);
            const getRequestConnect = store.get(key);
            const getRequestConnectEvent = await this.createDBOperationListeners(getRequestConnect);
            const data = getRequestConnectEvent.target.result;
            if (!data) {
                return;
            }
            store.put({ data: newData, addedAt: new Date().getTime() }, key);
            await this.keepLatestRecords(storageName);
        };
    }
}

class IndexDBBreadcrumbsService extends IndexDBService {
    constructor() {
        super(...arguments);
        this.getValidatedBreadcrumbs = async ({ key, storageName }) => {
            const result = await this.getFromStorage({ key, storageName });
            const breadcrumbType = this.channel === ClientApps.PBS
                ? BreadcrumbTypes.PBS
                : BreadcrumbTypes.PPW;
            const areBreadcrumbsCompleted = areBreadcrumbsLevelsValid(result, key, breadcrumbType);
            return areBreadcrumbsCompleted ? result : [];
        };
        this.fetchExistingOrNew = async ({ storageName, pageKey, breadcrumbs }) => {
            const isKeyExists = await this.checkKeyExisting(storageName, pageKey);
            if (!isKeyExists) {
                return this.addToStorage({
                    storageName,
                    objectToAdd: breadcrumbs,
                    key: pageKey,
                });
            }
            return this.getValidatedBreadcrumbs({
                storageName,
                key: pageKey,
            });
        };
        this.createOrUpdate = async ({ storageName, storageKey, updatedBreadCrumbs, }) => {
            const isKeyExists = await this.checkKeyExisting(storageName, storageKey);
            if (isKeyExists) {
                await this.updateStorage({
                    storageName,
                    key: storageKey,
                    newData: updatedBreadCrumbs,
                });
            }
            else {
                await this.addToStorage({
                    storageName,
                    objectToAdd: updatedBreadCrumbs,
                    key: storageKey,
                });
            }
        };
        this.setupStorage = async ({ breadcrumbs, storageName, pageKey, }) => {
            await this.connectDataBase();
            if (this.checkStorageExisting(storageName)) {
                return this.fetchExistingOrNew({ storageName, pageKey, breadcrumbs });
            }
            await this.setNewStorage({
                dataToInsert: breadcrumbs,
                key: pageKey,
                storageName,
            });
        };
        this.handleSaveInIndexDB = async (params) => {
            const { pageName, targetId, baseBreadCrumbs, storageName, targetName, targetUrl, parentRange, parentSubCategory, parentCategory, parentBusiness, } = params;
            const pageKey = `${pageName}/${targetId}`;
            const isKeyExists = await this.checkKeyExisting(storageName, pageKey);
            const updatedBreadcrumbs = [...baseBreadCrumbs,
                ...(parentBusiness ? [parentBusiness] : []),
                ...(parentCategory ? [parentCategory] : []),
                ...(parentSubCategory ? [parentSubCategory] : []),
                ...(parentRange ? [parentRange] : []),
                {
                    id: targetId,
                    itemType: pageName,
                    name: targetName,
                    nameForChat: '',
                    url: targetUrl,
                }];
            if (isKeyExists) {
                await this.updateStorage({
                    storageName,
                    key: pageKey,
                    newData: updatedBreadcrumbs,
                });
            }
            else {
                await this.addToStorage({
                    storageName,
                    objectToAdd: updatedBreadcrumbs,
                    key: pageKey,
                });
            }
            if (this.channel !== ClientApps.PPW) {
                return;
            }
            window.location.href = targetUrl;
        };
        this.buildBreadcrumbsForBusiness = async ({ storageName, getActiveBusinessCallBack, id, }) => {
            const activeBusiness = getActiveBusinessCallBack(id);
            const breadcrumbsFromStorage = await this.getValidatedBreadcrumbs({
                storageName,
                key: `${ALLPRODUCTS}/`,
            });
            const businessPageBreadcrumbItem = {
                id,
                itemType: BUSINESS,
                name: activeBusiness.name,
                nameForChat: '',
                url: activeBusiness.url,
            };
            const additionalBreadcrumbs = this.channel === ClientApps.PBS
                ? []
                : [businessPageBreadcrumbItem];
            return breadcrumbsFromStorage.concat(additionalBreadcrumbs);
        };
        this.getExistingOrUpdateForBusiness = async ({ storageName, currentPageStorageKey, id, getActiveBusinessCallBack, }) => {
            await this.connectDataBase();
            const isKeyExists = await this.checkKeyExisting(storageName, currentPageStorageKey);
            if (isKeyExists) {
                return this.getValidatedBreadcrumbs({
                    storageName,
                    key: currentPageStorageKey,
                });
            }
            if (!id)
                return [];
            const updatedBreadCrumbs = await this.buildBreadcrumbsForBusiness({
                storageName,
                getActiveBusinessCallBack,
                id,
            });
            await this.addToStorage({
                storageName,
                objectToAdd: updatedBreadCrumbs,
                key: currentPageStorageKey,
            });
            return updatedBreadCrumbs;
        };
    }
}
const indexDBBreadcrumbs = new IndexDBBreadcrumbsService();

function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return "'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return !!n&&!!n[Q]}function t(n){var r;return !!n&&(function(n){if(!n||"object"!=typeof n)return !1;var r=Object.getPrototypeOf(n);if(null===r)return !0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!(null===(r=n.constructor)||void 0===r?void 0:r[L])||s(n)||v(n))}function i(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n);})):n.forEach((function(t,e){return r(e,t,n)}));}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?n.add(t):n[r]=t;}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]});}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!t(n)||(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,r){return d(r,!0)}),!0)),n}function h(){n(2);}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n(18,r),t}function m(n,r){tn[n]||(tn[n]=r);}function _(){return U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r);}function g(n){O(n),n.p.forEach(S),n.p=null;}function O(n){n===U&&(U=n.l);}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.g=!0;}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.O||b("ES5").S(e,r,o),o?(i[Q].P&&(g(e),n(4)),t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q].t,r,e.u,e.s)):r=M(e,i,[]),g(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o,u=o,a=!1;3===e.i&&(u=new Set(o),o.clear(),a=!0),i(u,(function(r,i){return A(n,e,o,r,i,t,a)})),x(n,o,!1),t&&n.u&&b("Patches").N(e,t,n.u,n.s);}return e.o}function A(e,i,o,a,c,s,v){if(r(c)){var p=M(e,c,s&&i&&3!==i.i&&!u(i.R,a)?s.concat(a):void 0);if(f(o,a,p),!r(p))return;e.m=!1;}else v&&o.add(c);if(t(c)&&!y(c)){if(!e.h.D&&e._<1)return;M(e,c),i&&i.A.l||x(e,c);}}function x(n,r,t){void 0===t&&(t=!1),!n.l&&n.h.D&&n.m&&d(r,t);}function z(n,r){var t=n[Q];return (t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t);}}function k(n){n.P||(n.P=!0,n.l&&k(n.l));}function E(n){n.o||(n.o=l(n.t));}function N(n,r,t){var e=s(r)?b("MapSet").F(r,t):v(r)?b("MapSet").T(r,t):n.O?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return (t?t.A:_()).p.push(e),e}function R$1(e){return r(e)||n(22,e),function n(r){if(!t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=D(r,c),u.I=!1;}else e=D(r,c);return i(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t));})),3===c?new Set(e):e}(e)}function D(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function F(){function t(n,r){var t=s[n];return t?t.enumerable=r:s[n]=t={configurable:!0,enumerable:r,get:function(){var r=this[Q];return en.get(r,n)},set:function(r){var t=this[Q];en.set(t,n,r);}},t}function e(n){for(var r=n.length-1;r>=0;r--){var t=n[r][Q];if(!t.P)switch(t.i){case 5:a(t)&&k(t);break;case 4:o(t)&&k(t);}}}function o(n){for(var r=n.t,t=n.k,e=nn(t),i=e.length-1;i>=0;i--){var o=e[i];if(o!==Q){var a=r[o];if(void 0===a&&!u(r,o))return !0;var f=t[o],s=f&&f[Q];if(s?s.t!==a:!c(f,a))return !0}}var v=!!r[Q];return e.length!==nn(r).length+(v?0:1)}function a(n){var r=n.k;if(r.length!==n.t.length)return !0;var t=Object.getOwnPropertyDescriptor(r,r.length-1);if(t&&!t.get)return !0;for(var e=0;e<r.length;e++)if(!r.hasOwnProperty(e))return !0;return !1}var s={};m("ES5",{J:function(n,r){var e=Array.isArray(n),i=function(n,r){if(n){for(var e=Array(r.length),i=0;i<r.length;i++)Object.defineProperty(e,""+i,t(i,!0));return e}var o=rn(r);delete o[Q];for(var u=nn(o),a=0;a<u.length;a++){var f=u[a];o[f]=t(f,n||!!o[f].enumerable);}return Object.create(Object.getPrototypeOf(r),o)}(e,n),o={i:e?5:4,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:i,o:null,g:!1,C:!1};return Object.defineProperty(i,Q,{value:o,writable:!0}),i},S:function(n,t,o){o?r(t)&&t[Q].A===n&&e(n.p):(n.u&&function n(r){if(r&&"object"==typeof r){var t=r[Q];if(t){var e=t.t,o=t.k,f=t.R,c=t.i;if(4===c)i(o,(function(r){r!==Q&&(void 0!==e[r]||u(e,r)?f[r]||n(o[r]):(f[r]=!0,k(t)));})),i(e,(function(n){void 0!==o[n]||u(o,n)||(f[n]=!1,k(t));}));else if(5===c){if(a(t)&&(k(t),f.length=!0),o.length<e.length)for(var s=o.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<o.length;v++)f[v]=!0;for(var p=Math.min(o.length,e.length),l=0;l<p;l++)o.hasOwnProperty(l)||(f[l]=!0),void 0===f[l]&&n(o[l]);}}}}(n.p[0]),e(n.p));},K:function(n){return 4===n.i?o(n):a(n)}});}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t);})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=N(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.R[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return !0;E(n),k(n);}return n.o[r]===t&&(void 0!==t||r in n.o)||Number.isNaN(t)&&Number.isNaN(n.o[r])||(n.o[r]=t,n.R[r]=!0),!0},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.R[r]=!1,E(n),k(n)):delete n.R[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11);},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12);}},on={};i(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)};})),on.deleteProperty=function(r,t){return on.set.call(this,r,t,void 0)},on.set=function(r,t,e){return en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.O=B,this.D=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return (t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),t(r)){var c=w(e),s=N(e,r,void 0),v=!0;try{f=i(s),v=!1;}finally{v?g(c):O(c);}return "undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw g(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if(void 0===(f=i(r))&&(f=r),f===H&&(f=void 0),e.D&&d(f,!0),o){var p=[],l=[];b("Patches").M(r,f,p,l),o(p,l);}return f}n(21,r);},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,o=e.produce(n,r,(function(n,r){t=n,i=r;}));return "undefined"!=typeof Promise&&o instanceof Promise?o.then((function(n){return [n,t,i]})):[o,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze);}var i=e.prototype;return i.createDraft=function(e){t(e)||n(8),r(e)&&(e=R$1(e));var i=w(this),o=N(this,e,void 0);return o[Q].C=!0,O(i),o},i.finishDraft=function(r,t){var e=r&&r[Q];var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.D=n;},i.setUseProxies=function(r){r&&!B&&n(20),this.O=r;},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t)}))},e}(),an=new un,fn=an.produce;an.produceWithPatches.bind(an);an.setAutoFreeze.bind(an);an.setUseProxies.bind(an);an.applyPatches.bind(an);an.createDraft.bind(an);an.finishDraft.bind(an);

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject$1(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error(formatProdErrorMessage(0) );
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error(formatProdErrorMessage(1) );
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error(formatProdErrorMessage(2) );
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error(formatProdErrorMessage(3) );
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error(formatProdErrorMessage(4) );
    }

    if (isDispatching) {
      throw new Error(formatProdErrorMessage(5) );
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error(formatProdErrorMessage(6) );
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject$1(action)) {
      throw new Error(formatProdErrorMessage(7) );
    }

    if (typeof action.type === 'undefined') {
      throw new Error(formatProdErrorMessage(8) );
    }

    if (isDispatching) {
      throw new Error(formatProdErrorMessage(9) );
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error(formatProdErrorMessage(10) );
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error(formatProdErrorMessage(11) );
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error(formatProdErrorMessage(12) );
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error(formatProdErrorMessage(13) );
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        throw new Error(formatProdErrorMessage(14) );
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error(formatProdErrorMessage(15) );
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2(_objectSpread2({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}

/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function (obj, key, value) { return key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value; };
var __spreadValues = function (a, b) {
    for (var prop in b || (b = {}))
        if (__hasOwnProp.call(b, prop))
            __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
        for (var _i = 0, _c = __getOwnPropSymbols(b); _i < _c.length; _i++) {
            var prop = _c[_i];
            if (__propIsEnum.call(b, prop))
                __defNormalProp(a, prop, b[prop]);
        }
    return a;
};
var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
    if (arguments.length === 0)
        return void 0;
    if (typeof arguments[0] === "object")
        return compose;
    return compose.apply(null, arguments);
};
// src/isPlainObject.ts
function isPlainObject(value) {
    if (typeof value !== "object" || value === null)
        return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null)
        return true;
    var baseProto = proto;
    while (Object.getPrototypeOf(baseProto) !== null) {
        baseProto = Object.getPrototypeOf(baseProto);
    }
    return proto === baseProto;
}
// src/createAction.ts
function createAction(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) {
                throw new Error("prepareAction did not return an object");
            }
            return __spreadValues(__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && { meta: prepared.meta }), "error" in prepared && { error: prepared.error });
        }
        return { type: type, payload: args[0] };
    }
    actionCreator.toString = function () { return "" + type; };
    actionCreator.type = type;
    actionCreator.match = function (action) { return action.type === type; };
    return actionCreator;
}
var MiddlewareArray = /** @class */ (function (_super) {
    __extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function () {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        if (arr.length === 1 && Array.isArray(arr[0])) {
            return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr[0].concat(this))))();
        }
        return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array));
var EnhancerArray = /** @class */ (function (_super) {
    __extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function () {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        if (arr.length === 1 && Array.isArray(arr[0])) {
            return new (EnhancerArray.bind.apply(EnhancerArray, __spreadArray([void 0], arr[0].concat(this))))();
        }
        return new (EnhancerArray.bind.apply(EnhancerArray, __spreadArray([void 0], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array));
function freezeDraftable(val) {
    return t(val) ? fn(val, function () {
    }) : val;
}
// src/getDefaultMiddleware.ts
function isBoolean(x) {
    return typeof x === "boolean";
}
function curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return getDefaultMiddleware(options);
    };
}
function getDefaultMiddleware(options) {
    if (options === void 0) { options = {}; }
    var _c = options.thunk, thunk$1 = _c === void 0 ? true : _c;
    var middlewareArray = new MiddlewareArray();
    if (thunk$1) {
        if (isBoolean(thunk$1)) {
            middlewareArray.push(thunk);
        }
        else {
            middlewareArray.push(thunk.withExtraArgument(thunk$1.extraArgument));
        }
    }
    return middlewareArray;
}
// src/configureStore.ts
var IS_PRODUCTION = "production" === "production";
function configureStore(options) {
    var curriedGetDefaultMiddleware = curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") {
        rootReducer = reducer;
    }
    else if (isPlainObject(reducer)) {
        rootReducer = combineReducers(reducer);
    }
    else {
        throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    }
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
    }
    var middlewareEnhancer = applyMiddleware.apply(void 0, finalMiddleware);
    var finalCompose = compose;
    if (devTools) {
        finalCompose = composeWithDevTools(__spreadValues({
            trace: !IS_PRODUCTION
        }, typeof devTools === "object" && devTools));
    }
    var defaultEnhancers = new EnhancerArray(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) {
        storeEnhancers = __spreadArray([middlewareEnhancer], enhancers);
    }
    else if (typeof enhancers === "function") {
        storeEnhancers = enhancers(defaultEnhancers);
    }
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return createStore(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function (typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) {
                throw new Error("`builder.addCase` cannot be called with an empty action type");
            }
            if (type in actionsMap) {
                throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            }
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function (matcher, reducer) {
            actionMatchers.push({ matcher: matcher, reducer: reducer });
            return builder;
        },
        addDefaultCase: function (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [actionsMap, actionMatchers, defaultCaseReducer];
}
// src/createReducer.ts
function isStateFunction(x) {
    return typeof x === "function";
}
function createReducer(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) { actionMatchers = []; }
    var _c = typeof mapOrBuilderCallback === "function" ? executeReducerBuilderCallback(mapOrBuilderCallback) : [mapOrBuilderCallback, actionMatchers, defaultCaseReducer], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if (isStateFunction(initialState)) {
        getInitialState = function () { return freezeDraftable(initialState()); };
    }
    else {
        var frozenInitialState_1 = freezeDraftable(initialState);
        getInitialState = function () { return frozenInitialState_1; };
    }
    function reducer(state, action) {
        if (state === void 0) { state = getInitialState(); }
        var caseReducers = __spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function (_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function (_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function (cr) { return !!cr; }).length === 0) {
            caseReducers = [finalDefaultCaseReducer];
        }
        return caseReducers.reduce(function (previousState, caseReducer) {
            if (caseReducer) {
                if (r(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) {
                        return previousState;
                    }
                    return result;
                }
                else if (!t(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) {
                            return previousState;
                        }
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                }
                else {
                    return fn(previousState, function (draft) {
                        return caseReducer(draft, action);
                    });
                }
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
function getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function createSlice(options) {
    var name = options.name;
    if (!name) {
        throw new Error("`name` is a required option for createSlice");
    }
    if (typeof process_1 !== "undefined" && "production" === "development") {
        if (options.initialState === void 0) {
            console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
        }
    }
    var initialState = typeof options.initialState == "function" ? options.initialState : freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function (reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        }
        else {
            caseReducer = maybeReducerWithPrepare;
        }
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? createAction(type, prepareCallback) : createAction(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [options.extraReducers], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = __spreadValues(__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return createReducer(initialState, function (builder) {
            for (var key in finalCaseReducers) {
                builder.addCase(key, finalCaseReducers[key]);
            }
            for (var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++) {
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) {
                builder.addDefaultCase(defaultCaseReducer);
            }
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function (state, action) {
            if (!_reducer)
                _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function () {
            if (!_reducer)
                _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
var alm = "listenerMiddleware";
createAction(alm + "/add");
createAction(alm + "/removeAll");
createAction(alm + "/remove");
var promise;
typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : globalThis) : function (cb) { return (promise || (promise = Promise.resolve())).then(cb).catch(function (err) { return setTimeout(function () {
    throw err;
}, 0); }); };
// src/index.ts
F();

var __rest$1 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const ACTION_TYPES = {
    SET_ACTIVE_PRODUCT_TAB: 'product/setActiveProductTab',
    SET_LINEAR_PRODUCT_DATA: 'product/setLinearProductData',
    SET_CIRCULAR_PRODUCT_DATA: 'product/setCircularProductData',
    SET_ERROR: 'product/setError',
    START_LOADING: 'product/startLoading',
    STOP_LOADING: 'product/stopLoading',
};
const productSlice = createSlice({
    name: 'product',
    initialState: {
        data: {
            [CircularProductTypes.LINEAR]: null,
            [CircularProductTypes.REFURBISHED]: null,
            [CircularProductTypes.REPACKED]: null,
            [CircularProductTypes.REMANUFACTURED]: null,
        },
        activeProductTab: CircularProductTypes.LINEAR,
        status: STATUS_TYPES.IDLE,
        error: null,
        lastActionType: null,
    },
    reducers: {
        setLinearProductData(state, action) {
            const newState = lodash.cloneDeep(state);
            newState.data[CircularProductTypes.LINEAR] = lodash.merge({}, newState.data[CircularProductTypes.LINEAR], action.payload);
            newState.lastActionType = action.type;
            return newState;
        },
        setCircularProductData(state, action) {
            const newState = lodash.cloneDeep(state);
            const _a = action.payload, { circularType } = _a, restPayload = __rest$1(_a, ["circularType"]);
            newState.data[circularType] = lodash.merge({}, newState.data[circularType], restPayload);
            newState.status = STATUS_TYPES.SUCCEEDED;
            newState.error = null;
            newState.lastActionType = action.type;
            return newState;
        },
        setActiveProductTab(state, action) {
            return Object.assign(Object.assign({}, state), { activeProductTab: action.payload, lastActionType: action.type });
        },
        startLoading(state, action) {
            return Object.assign(Object.assign({}, state), { status: STATUS_TYPES.LOADING, lastActionType: action.type });
        },
        setError(state, action) {
            return Object.assign(Object.assign({}, state), { status: STATUS_TYPES.FAILED, error: action.payload, lastActionType: action.type });
        },
        stopLoading(state, action) {
            return Object.assign(Object.assign({}, state), { status: state.status === STATUS_TYPES.LOADING ? STATUS_TYPES.IDLE : state.status, lastActionType: action.type });
        },
    },
});
const { setActiveProductTab, setLinearProductData, startLoading, setCircularProductData, setError, stopLoading, } = productSlice.actions;

const store = configureStore({
    reducer: {
        product: productSlice.reducer,
    },
});

// Copyright Joyent, Inc. and other Node contributors.

var R = typeof Reflect === 'object' ? Reflect : null;
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  };

var ReflectOwnKeys;
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys;
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
};

function EventEmitter() {
  EventEmitter.init.call(this);
}
var events = EventEmitter;
var once_1 = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    }
    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}
events.once = once_1;

var TIMER_EVENTS;
(function (TIMER_EVENTS) {
    TIMER_EVENTS["STOP"] = "stop";
})(TIMER_EVENTS || (TIMER_EVENTS = {}));

function waitUntil(time, stopper) {
    return new Promise((resolve) => {
        var _a;
        let timer;
        function done(wasInterrupted = true) {
            var _a;
            resolve(!wasInterrupted);
            (_a = stopper === null || stopper === void 0 ? void 0 : stopper.removeListener) === null || _a === void 0 ? void 0 : _a.call(stopper, TIMER_EVENTS.STOP, done);
            if (timer)
                clearTimeout(timer);
        }
        (_a = stopper === null || stopper === void 0 ? void 0 : stopper.once) === null || _a === void 0 ? void 0 : _a.call(stopper, TIMER_EVENTS.STOP, done);
        timer = setTimeout(done, time, false);
    });
}

class RequestError extends Error {
    constructor(type) {
        const processedType = type in REQUEST_ERRORS ? type : REQUEST_ERROR_TYPES.DEFAULT;
        super(REQUEST_ERRORS[processedType].message);
        this.statusCode = REQUEST_ERRORS[processedType].statusCode;
    }
}

class RequestService extends events.EventEmitter {
    constructor(configurations) {
        super();
        this.APIDirectory = {};
        this.maxRetries = 0;
        this.defaultContentType = '';
        const mergedConfigurations = Object.assign({}, DEFAULT_CONFIGURATIONS, configurations);
        this.maxRetries = mergedConfigurations.maxRetries;
        this.defaultContentType = mergedConfigurations.defaultContentType;
        mergedConfigurations.APIConfigList.forEach((configuration) => this.setUpAPI(configuration));
    }
    setUpAPI(apiConfiguration) {
        var _a;
        const headers = (_a = apiConfiguration.standardSettings) === null || _a === void 0 ? void 0 : _a.headers;
        const { version } = apiConfiguration;
        this.APIDirectory[apiConfiguration.name] = {
            name: apiConfiguration.name,
            host: apiConfiguration.host,
            version: apiConfiguration.version,
            apiKey: apiConfiguration.apiKey,
            requestTimeout: apiConfiguration.requestTimeout,
            maxRetries: apiConfiguration.maxRetries,
            standardSettings: Object.assign(Object.assign({}, (apiConfiguration.standardSettings || {})), { headers: Object.assign(Object.assign({}, (headers || {})), { 'Content-Type': `${(headers === null || headers === void 0 ? void 0 : headers['Content-Type']) || this.defaultContentType}${version ? (DEFAULT_API_VERSION_FORMAT + version) : ''}` }) }),
        };
    }
    processResponse(response, type) {
        return response[type]();
    }
    setAPISettingsFromWindow(targetApi, defaultApi) {
        var _a, _b;
        const apiList = (_b = (_a = window.pesConfigs) === null || _a === void 0 ? void 0 : _a.API) === null || _b === void 0 ? void 0 : _b.list;
        const targetFound = apiList === null || apiList === void 0 ? void 0 : apiList.find(({ name }) => targetApi === name);
        if (targetFound) {
            this.setUpAPI(targetFound);
            return;
        }
        if (this.APIDirectory[defaultApi])
            return;
        const defaultFound = apiList === null || apiList === void 0 ? void 0 : apiList.find(({ name }) => defaultApi === name);
        if (defaultFound) {
            this.setUpAPI(defaultFound);
            return;
        }
        throw new RequestError(REQUEST_ERROR_TYPES.SET_API_ERROR);
    }
    getFetchSettingsByAPI(settings, abortSignal) {
        var _a, _b, _c, _d;
        if (!(settings.api.target in this.APIDirectory)) {
            this.setAPISettingsFromWindow(settings.api.target, settings.api.default);
        }
        const foundAPIName = settings.api.target in this.APIDirectory
            ? settings.api.target
            : settings.api.default;
        const foundAPI = this.APIDirectory[foundAPIName];
        const copiedSettings = Object.assign({}, settings);
        if (((_b = (_a = settings.standardSettings) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b['Content-Type']) && foundAPI.version) {
            const contentType = copiedSettings.standardSettings.headers['Content-Type'];
            const APIVersion = foundAPI.version;
            copiedSettings.standardSettings.headers = Object.assign(Object.assign({}, settings.standardSettings.headers), { 'Content-Type': contentType + (APIVersion ? (DEFAULT_API_VERSION_FORMAT + APIVersion) : '') });
        }
        const mergedStandardSettings = lodash.merge({}, copiedSettings.standardSettings, this.APIDirectory[foundAPIName].standardSettings);
        return Object.assign(Object.assign({}, settings), { host: foundAPI.host || settings.host, timeout: (_c = foundAPI.requestTimeout) !== null && _c !== void 0 ? _c : settings.timeout, maxRetries: (_d = foundAPI.maxRetries) !== null && _d !== void 0 ? _d : settings.maxRetries, standardSettings: Object.assign(Object.assign({}, mergedStandardSettings), { signal: abortSignal }) });
    }
    get(url, settings) {
        const fullSettings = Object.assign(Object.assign({}, settings), { standardSettings: Object.assign(Object.assign({}, settings === null || settings === void 0 ? void 0 : settings.standardSettings), { method: 'GET' }) });
        return this.request(url, fullSettings, 0);
    }
    post(url, body, settings) {
        const fullSettings = Object.assign(Object.assign({}, settings), { standardSettings: Object.assign(Object.assign({}, settings === null || settings === void 0 ? void 0 : settings.standardSettings), { body, method: 'POST' }) });
        return this.request(url, fullSettings, 0);
    }
    patch(url, body, settings) {
        const fullSettings = Object.assign(Object.assign({}, settings), { standardSettings: Object.assign(Object.assign({}, settings === null || settings === void 0 ? void 0 : settings.standardSettings), { body, method: 'PATCH' }) });
        return this.request(url, fullSettings, 0);
    }
    put(url, body, settings) {
        const fullSettings = Object.assign(Object.assign({}, settings), { standardSettings: Object.assign(Object.assign({}, settings === null || settings === void 0 ? void 0 : settings.standardSettings), { body, method: 'PUT' }) });
        return this.request(url, fullSettings, 0);
    }
    delete(url, settings) {
        const fullSettings = Object.assign(Object.assign({}, settings), { standardSettings: Object.assign(Object.assign({}, settings === null || settings === void 0 ? void 0 : settings.standardSettings), { method: 'DELETE' }) });
        return this.request(url, fullSettings, 0);
    }
    async request(url, settings, retries = 0) {
        var _a, _b;
        let APIMaxRetries = 0;
        try {
            if (!settings) {
                const response = await (await fetch(url)).json();
                return { error: null, result: response };
            }
            const abortController = new AbortController();
            const timeoutStopper = new events.EventEmitter();
            let fetchSettings = null;
            if (settings.api) {
                fetchSettings = Object.assign({}, this.getFetchSettingsByAPI(settings, abortController.signal));
                APIMaxRetries = fetchSettings.maxRetries;
            }
            const processedSettings = fetchSettings || settings;
            if (processedSettings.timeout) {
                waitUntil(processedSettings.timeout, timeoutStopper).then((requestDidTimeout) => {
                    if (!requestDidTimeout)
                        return;
                    abortController.abort();
                });
            }
            let finalUrl = url;
            if (processedSettings.host && !url.startsWith('/')) {
                const urlObject = new URL(url);
                finalUrl = url.replace(urlObject.origin, '');
            }
            const response = await fetch(`${(_a = processedSettings.host) !== null && _a !== void 0 ? _a : ''}${finalUrl}`, processedSettings.standardSettings);
            timeoutStopper.emit(TIMER_EVENTS.STOP);
            if (!response.ok) {
                throw new RequestError(response.status);
            }
            const processedResponse = await this.processResponse(response, (_b = processedSettings.responseType) !== null && _b !== void 0 ? _b : RESPONSE_TYPES.JSON);
            return { error: null, result: processedResponse };
        }
        catch (error) {
            const maxRetries = (settings === null || settings === void 0 ? void 0 : settings.maxRetries) || APIMaxRetries || this.maxRetries || 0;
            const isAPISetupError = error instanceof RequestError
                && error.type === REQUEST_ERROR_TYPES.SET_API_ERROR;
            if (!isAPISetupError && maxRetries > 0 && retries < maxRetries) {
                return this.request(url, settings, retries + 1);
            }
            return { error: error, result: null };
        }
    }
}
const instance = new RequestService();
const RequestServiceInstance = instance;

class RequestHandler {
    constructor() {
        this.api = null;
    }
    get(url, settings) {
        return instance.get(url, Object.assign(Object.assign({ responseType: RESPONSE_TYPES.JSON }, (settings || {})), { api: this.api }));
    }
    post(url, settings) {
        return instance.post(url, Object.assign(Object.assign({ responseType: RESPONSE_TYPES.JSON }, (settings || {})), { api: this.api }));
    }
    patch(url, settings) {
        return instance.patch(url, Object.assign(Object.assign({ responseType: RESPONSE_TYPES.JSON }, (settings || {})), { api: this.api }));
    }
    put(url, settings) {
        return instance.put(url, Object.assign(Object.assign({ responseType: RESPONSE_TYPES.JSON }, (settings || {})), { api: this.api }));
    }
    delete(url, settings) {
        return instance.delete(url, Object.assign(Object.assign({ responseType: RESPONSE_TYPES.JSON }, (settings || {})), { api: this.api }));
    }
}

class UrlBuilder {
    static buildSprykerURL(parameters) {
        const { host = '', endPointName, brand = '', countryCode = '', languageCode, queryParams = {}, } = parameters;
        const url = `${host}${endPointName}?${new URLSearchParams(Object.assign({ brand: brand || getBrandName(), 'country-code': countryCode, 'language-code': languageCode }, queryParams))}`;
        return url;
    }
    static buildHmcURL(parameters) {
        const { host = '', endPointName, countryCode = '', languageCode, resources = '', queryParams = {}, } = parameters;
        const searchParams = new URLSearchParams(queryParams).toString();
        const urlQueryParams = searchParams ? `?${searchParams}` : '';
        return `${host}${endPointName}/${countryCode}/${languageCode}${resources}${urlQueryParams}`;
    }
}

const HMC_VISIBILITY_PATH = '/visibility';
var HMC_PAGE_PATH;
(function (HMC_PAGE_PATH) {
    HMC_PAGE_PATH["CATEGORY_PAGE"] = "/category_page";
    HMC_PAGE_PATH["SUBCATEGORY_PAGE"] = "/sub_category";
})(HMC_PAGE_PATH || (HMC_PAGE_PATH = {}));

class HmcCategoriesHandler extends RequestHandler {
    constructor() {
        super(...arguments);
        this.api = {
            target: 'hmc-categories',
            default: 'hmc-default',
        };
    }
    fetchCategoriesWithHMC(parameters) {
        return this.get(UrlBuilder.buildHmcURL(Object.assign(Object.assign({}, parameters), { queryParams: {
                pimIds: parameters.pimIds,
                hmcBanner: parameters.hmcBanner,
                platform: parameters.platform,
            }, endPointName: HMC_VISIBILITY_PATH, resources: HMC_PAGE_PATH.CATEGORY_PAGE })));
    }
    fetchSingleCategoryWithHMC(parameters) {
        return this.get(UrlBuilder.buildHmcURL(Object.assign(Object.assign({}, parameters), { endPointName: HMC_VISIBILITY_PATH, resources: HMC_PAGE_PATH.CATEGORY_PAGE })));
    }
}
const HmcCategories = new HmcCategoriesHandler();

class HmcSubcategoriesHandler extends RequestHandler {
    constructor() {
        super(...arguments);
        this.api = {
            target: 'hmc-subcategories',
            default: 'hmc-default',
        };
    }
    fetchSingleSubcategoryWithHMC(parameters) {
        return this.get(UrlBuilder.buildHmcURL(Object.assign(Object.assign({}, parameters), { endPointName: HMC_VISIBILITY_PATH, resources: HMC_PAGE_PATH.SUBCATEGORY_PAGE })));
    }
}
const HmcSubcategories = new HmcSubcategoriesHandler();

class SprykerCategoriesByBusinessHandler extends RequestHandler {
    constructor() {
        super(...arguments);
        this.api = {
            target: 'spryker-categories-by-business',
            default: 'spryker-default',
        };
    }
    fetchCategoriesByBusiness(url) {
        return this.get(url);
    }
}
const SprykerCategoriesByBusiness = new SprykerCategoriesByBusinessHandler();

class SprykerCommerceConnectorHandler extends RequestHandler {
    constructor() {
        super(...arguments);
        this.api = {
            target: 'spryker-commerce-connector',
            default: 'spryker-default',
        };
    }
    getCommerceConnector(parameters) {
        if (typeof parameters.url === 'string') {
            return this.get(parameters.url);
        }
        return this.get(UrlBuilder.buildSprykerURL(Object.assign(Object.assign({}, parameters.url), { endPointName: SPRYKER_COMMERCE_CONNECTOR_PATH })));
    }
}
const SprykerCommerceConnector = new SprykerCommerceConnectorHandler();

class SprykerProductsSelectorConfigHandler extends RequestHandler {
    constructor() {
        super(...arguments);
        this.api = {
            target: 'spryker-products-selector-config',
            default: 'spryker-default',
        };
    }
    fetchProductsSelectorConfig(url) {
        return this.get(url);
    }
}
const SprykerProductsSelectorConfig = new SprykerProductsSelectorConfigHandler();

class ApigeeCircularStockAvailabilityHandler extends RequestHandler {
    constructor() {
        super(...arguments);
        this.api = {
            target: 'apigee-circular-stock-availability',
            default: 'apigee-default',
        };
    }
    getCircularStockAvailability({ url, apiKey, queryParams }) {
        const params = new URLSearchParams(queryParams);
        const urlWithParams = `${url}?${params}`;
        if (!apiKey) {
            return this.get(urlWithParams);
        }
        return this.get(urlWithParams, {
            standardSettings: {
                headers: {
                    apikey: apiKey,
                },
            },
        });
    }
}
const ApigeeCircularStockAvailability = new ApigeeCircularStockAvailabilityHandler();

var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
class SprykerProductCardMainHandler extends RequestHandler {
    constructor() {
        super(...arguments);
        this.api = {
            target: 'spryker-product-card-main',
            default: 'spryker-default',
        };
    }
    getProductCardMain(_a) {
        var { productIdList } = _a, parameters = __rest(_a, ["productIdList"]);
        return this.get(UrlBuilder.buildSprykerURL(Object.assign(Object.assign({}, parameters), { endPointName: SPRYKER_PRODUCT_CARD_MAIN_PATH, queryParams: { ids: productIdList } })));
    }
}
const SprykerProductCardMain = new SprykerProductCardMainHandler();

class SprykerProductsAllHandler extends RequestHandler {
    constructor() {
        super(...arguments);
        this.api = {
            target: 'spryker-products-all',
            default: 'spryker-default',
        };
    }
    getProductsAll({ countryCode, languageCode, productId, brand, idmsToken, }) {
        const headers = {};
        if (idmsToken) {
            headers['User-Authorization'] = idmsToken;
        }
        return this.get(UrlBuilder.buildSprykerURL({
            countryCode,
            languageCode,
            brand,
            endPointName: SPRYKER_PRODUCTS_ALL_PATH.replace('#product_id#', productId),
        }), {
            standardSettings: {
                headers,
            },
        });
    }
}
const SprykerProductsAll = new SprykerProductsAllHandler();

class SprykerDdcConfigHandler extends RequestHandler {
    constructor() {
        super(...arguments);
        this.api = {
            target: 'spryker-ddc-config',
            default: 'spryker-default',
        };
    }
    getDdcConfig({ countryCode, languageCode, brand, }) {
        return this.get(UrlBuilder.buildSprykerURL({
            countryCode,
            languageCode,
            brand,
            endPointName: SPRYKER_DDC_CONFIG_PATH,
        }));
    }
}
const SprykerDdcConfig = new SprykerDdcConfigHandler();

class ConfiguratorHandler {
    static isFeatureFlagEnabled(flag) {
        return flag.status === FeatureStatus.ENABLED;
    }
    static getSingleConfig(configName) {
        var _a, _b;
        return (_b = (_a = window[ConfiguratorHandler.id]) === null || _a === void 0 ? void 0 : _a[configName]) !== null && _b !== void 0 ? _b : null;
    }
    static setSingleConfig(configName, configValue) {
        if (typeof window[ConfiguratorHandler.id] !== 'object' || window[ConfiguratorHandler.id] === null) {
            console.warn(`[PES]: window object did not have ${ConfiguratorHandler.id} initialized.`);
            window[ConfiguratorHandler.id] = {};
        }
        window[ConfiguratorHandler.id][configName] = configValue;
    }
    static getLocalizedEnabledFeatures(features, locale) {
        const result = {
            [PES_FLAGS.Substitutions]: { status: FeatureStatus.DISABLED },
            [PES_FLAGS.UnifiedCheckout]: { status: FeatureStatus.DISABLED },
        };
        // eslint-disable-next-line no-restricted-syntax
        for (const [key, attributes] of Object.entries(features)) {
            if (attributes.locales !== '*' && !attributes.locales.includes(locale)) {
                result[PES_FLAGS[key]] = { status: FeatureStatus.DISABLED };
                continue;
            }
            result[PES_FLAGS[key]] = Object.assign(Object.assign({}, attributes), { status: FeatureStatus.ENABLED });
            delete result[PES_FLAGS[key]].locales;
        }
        return result;
    }
    static setupGlobalConfigs(configs, country, language) {
        if (!country || !language) {
            console.warn('[PES]: country or language was not provided.');
            return;
        }
        const currentLocale = `${country}_${language}`.toLowerCase();
        const Widgets = {};
        const { Widgets: widgetConf } = configs;
        if (widgetConf) {
            Object.entries(widgetConf).forEach(([widgetType, widgetConfigs]) => {
                var _a;
                const currentLocalWidget = (_a = (widgetConfigs)) === null || _a === void 0 ? void 0 : _a.find((config) => (config === null || config === void 0 ? void 0 : config.locales) === '*' || (Array.isArray(config === null || config === void 0 ? void 0 : config.locales) && (config === null || config === void 0 ? void 0 : config.locales.includes(currentLocale))));
                if (!(currentLocalWidget === null || currentLocalWidget === void 0 ? void 0 : currentLocalWidget.attributes))
                    return;
                Widgets[widgetType] = currentLocalWidget === null || currentLocalWidget === void 0 ? void 0 : currentLocalWidget.attributes;
            });
        }
        const pesConfigs = {};
        if (configs.LocalizedFeatures) {
            pesConfigs.FeatureFlags = ConfiguratorHandler.getLocalizedEnabledFeatures(configs.LocalizedFeatures, currentLocale);
        }
        if (Object.keys(Widgets).length) {
            pesConfigs.Widgets = Widgets;
        }
        if (configs.api) {
            pesConfigs.API = configs.api;
        }
        window[ConfiguratorHandler.id] = pesConfigs;
    }
}
ConfiguratorHandler.id = 'pesConfigs';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

var _setCacheAdd = setCacheAdd;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new _MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
SetCache.prototype.has = _setCacheHas;

var _SetCache = SetCache;

// Global visibility
window.pes = window.pes || {};
window.pes.validateCountryLanguage = validate;

export { isHostnameContainsCC as $, convertToPx as A, encodeProductId as B, isTargetBlank as C, isLinkTypeOnline as D, sendEvent as E, getYouTubeVideoIDFromURL as F, urlDecode as G, isSVG as H, isUrl as I, getCTAClickEventParams as J, arrayToMap as K, makeId as L, MediaGalleryImageExtensions as M, COMPARATOR_LOCALE as N, sleep as O, allFinished as P, getComparisonSessionId as Q, getComparatorThreshold as R, getStorageComparatorName as S, MAX_COMPARATOR_ITEMS as T, comparator as U, getComparatorUrl as V, getSlottedContent as W, getProductCtasLabels as X, addPageLoadDataInfoToAnalyticsEvent as Y, ExcelJSService as Z, getBrandName as _, isPBS as a, ATG_PRODUCT_SOFTWARE_PATH as a$, getBodyLanguageCode as a0, getBodyCountryCode as a1, getConsumerSpecificData as a2, buildLocaleCode as a3, formatToLocaleString as a4, transformLocaleToBCP47LanguageTag as a5, getLookup as a6, getLookupValueFunction as a7, getLookupValueAddCartLocation as a8, getLookupValueAddCartCTAType as a9, RequestService as aA, RequestServiceInstance as aB, RequestHandler as aC, SprykerCategoriesByBusinessHandler as aD, SprykerCategoriesByBusiness as aE, SprykerCommerceConnectorHandler as aF, SprykerCommerceConnector as aG, SprykerProductsSelectorConfigHandler as aH, SprykerProductsSelectorConfig as aI, UrlBuilder as aJ, ApigeeCircularStockAvailabilityHandler as aK, ApigeeCircularStockAvailability as aL, SprykerProductCardMainHandler as aM, SprykerProductCardMain as aN, SprykerProductsAllHandler as aO, SprykerProductsAll as aP, SprykerDdcConfigHandler as aQ, SprykerDdcConfig as aR, ConfiguratorHandler as aS, isNullOrUndefined as aT, getDefaultCountry as aU, getExistOrDefaultLanguage as aV, validate as aW, _SetCache as aX, noop_1 as aY, SPRYKER_PRODUCT_CARD_SECONDARY_PATH as aZ, SPRYKER_PRODUCT_CARD_MAIN_PATH as a_, getLookupValueProductLists as aa, getLookupValueVirtualPageType as ab, getLookupValueVirtualPageName as ac, getLookupValuePageTabs as ad, Method as ae, initBrowserAxios as af, callAxios as ag, fetchers as ah, areBreadcrumbsLevelsValid as ai, filterBreadcrumbsForSaving as aj, IndexDBService as ak, IndexDBBreadcrumbsService as al, indexDBBreadcrumbs as am, store as an, ACTION_TYPES as ao, productSlice as ap, setActiveProductTab as aq, setLinearProductData as ar, startLoading as as, setCircularProductData as at, setError as au, stopLoading as av, HmcCategoriesHandler as aw, HmcCategories as ax, HmcSubcategoriesHandler as ay, HmcSubcategories as az, isIndexDBEnabled as b, isPublicEnvironment as c, getLocaleFromURL as d, buildURL as e, getSDLHeaderSelector as f, getLocaleFromBody as g, getHeaderHeight as h, isV3 as i, consoleErrorMsg as j, hasHttpOrHttps as k, tryStringify as l, mergeUrlWithHost as m, isEmpty as n, parseJsonResponse as o, productCartPageVersion as p, parseJSONString as q, isValidUrl as r, scrollToComponent as s, tryParse as t, useReplatformedHMC as u, validateHost as v, transformCamelCaseString as w, deepMerge as x, getDataAttributes as y, roundHalf as z };
